import { createAction, handleActions } from "redux-actions";
import produce from "immer";
import createRequestThunk from "../lib/createRequestThunk";
import i18n from "../locales/config";

import ConstData from "../lib/ConstData";

import {
    check_sub_domain,
    change_sub_domain_logo,
    reset_user_login_status,
    reset_user_pw,
    get_manage_sub_domain_list,
    add_sub_domain_info,
    add_sub_domain_config_admin,
    remove_sub_domain_config_admin,
    add_sub_domain_create_admin,
    remove_sub_domain_create_admin,
    get_sub_domain_local_server_info,
    get_user_local_server_info,
    search_user,
    duplicate_check_users,
    create_users,
    get_all_content_teachers,
    create_content_teachers,
    update_content_teacher_use_yn,
    update_content_teacher_name,
    update_content_teacher_info,
    delete_content_teacher,
    get_all_live_list,
    update_live_info,
    delete_live,
    get_all_content_urls,
    create_content_urls,
    update_content_url_info,
    delete_content_url,
    get_media_gateway_list
} from "../lib/api/admin";

import {
    get_lite_server_list,
    create_lite_server,
    remove_lite_server,
    change_lite_server_info
} from "../lib/api/lite-local";

import {
    change_local_server_port_info,
    change_local_site_info,
    change_local_server_config_info,
    // 20260828 로컬 서버/로컬 사이트 이름 인라인 수정용 API 추가
    change_local_server_name,
    change_local_site_name,
    get_local_site_list,
    create_local_site,
    delete_local_site,
    class_close_on_local_site,
    class_open_on_local_site,
    create_local_server,
    remove_local_server,
    get_local_server_types,
    update_local_server_type_use,
    update_local_server_types_use,
    get_local_server_command_info,
    send_local_server_command
} from "../lib/api/local";

// 20261023 비밀번호를 포함하지 않는 초기화 완료 정보만 상태에 반영한다.
export const reportTokenResetCompleted = createAction("admin/REPORT_TOKEN_RESET_COMPLETED");

// 20260917 실시간 ACK의 ISO UTC 시각을 관리자 화면의 한국 시간 형식으로 통일한다.
const formatCapabilityDateTime = (value) => {
    if (!value) return value;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleString("sv-SE", {
        timeZone: "Asia/Seoul",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
    });
};

export const SUB_DOMAIN_STATE_INIT              = "admin/SUB_DOMAIN_INIT";
export const SUB_DOMAIN_INFO_INIT               = "admin/SUB_DOMAIN_INFO_INIT";

const SELECT_SUB_DOMAIN_INFO                    = "admin/SELECT_SUB_DOMAIN_INFO";
const SELECT_USER_INFO                          = "admin/SELECT_USER_INFO";

const FIND_USER                                 = "admin/FIND_USER";
const FIND_USER_SUCCESS                         = "admin/FIND_USER_SUCCESS";

const GET_MANAGE_SUB_DOMAIN_INFO                = "admin/GET_MANAGE_SUB_DOMAIN_INFO";
const GET_MANAGE_SUB_DOMAIN_INFO_SUCCESS        = "admin/GET_MANAGE_SUB_DOMAIN_INFO_SUCCESS";

const ADD_SUB_DOMAIN                            = "admin/ADD_SUB_DOMAIN";
const ADD_SUB_DOMAIN_SUCCESS                    = "admin/ADD_SUB_DOMAIN_SUCCESS";

const CHECK_SUB_DOMAIN                          = "admin/CHECK_SUB_DOMAIN";
const CHECK_SUB_DOMAIN_SUCCESS                  = "admin/CHECK_SUB_DOMAIN_SUCCESS";
const CHECK_DUPLICATE_SUB_DOMAIN                = "admin/CHECK_DUPLICATE_SUB_DOMAIN";
const CHECK_DUPLICATE_SUB_DOMAIN_SUCCESS        = "admin/CHECK_DUPLICATE_SUB_DOMAIN_SUCCESS";

const CHANGE_SUB_DOMAIN_LOGO                    = "admin/CHANGE_SUB_DOMAIN_LOGO";
const CHANGE_SUB_DOMAIN_LOGO_SUCCESS            = "admin/CHANGE_SUB_DOMAIN_LOGO_SUCCESS";

const RESET_USER_LOGIN_STATUS                   = "admin/RESET_USER_LOGIN_STATUS";
const RESET_USER_LOGIN_STATUS_SUCCESS           = "admin/RESET_USER_LOGIN_STATUS_SUCCESS";
const RESET_USER_PW                             = "admin/RESET_USER_PW";
const RESET_USER_PW_SUCCESS                     = "admin/RESET_USER_PW_SUCCESS";

const ADD_SUB_DOMAIN_CONFIG_ADMIN               = "admin/ADD_SUB_DOMAIN_CONFIG_ADMIN";
const ADD_SUB_DOMAIN_CONFIG_ADMIN_SUCCESS       = "admin/ADD_SUB_DOMAIN_CONFIG_ADMIN_SUCCESS";
const ADD_SUB_DOMAIN_CREATE_ADMIN               = "admin/ADD_SUB_DOMAIN_CREATE_ADMIN";
const ADD_SUB_DOMAIN_CREATE_ADMIN_SUCCESS       = "admin/ADD_SUB_DOMAIN_CREATE_ADMIN_SUCCESS";
const REMOVE_SUB_DOMAIN_CONFIG_ADMIN            = "admin/REMOVE_SUB_DOMAIN_CONFIG_ADMIN";
const REMOVE_SUB_DOMAIN_CONFIG_ADMIN_SUCCESS    = "admin/REMOVE_SUB_DOMAIN_CONFIG_ADMIN_SUCCESS";
const REMOVE_SUB_DOMAIN_CREATE_ADMIN            = "admin/REMOVE_SUB_DOMAIN_CREATE_ADMIN";
const REMOVE_SUB_DOMAIN_CREATE_ADMIN_SUCCESS    = "admin/REMOVE_SUB_DOMAIN_CREATE_ADMIN_SUCCESS";

const DUPLICATE_CHECK_USERS                     = "admin/DUPLICATE_CHECK_USERS";
const DUPLICATE_CHECK_USERS_SUCCESS             = "admin/DUPLICATE_CHECK_USERS_SUCCESS";
const CREATE_USERS                              = "admin/CREATE_USERS";
const CREATE_USERS_SUCCESS                      = "admin/CREATE_USERS_SUCCESS";

const SELECT_SUB_DOMAIN_CONFIG_INFO             = "admin/SELECT_SUB_DOMAIN_CONFIG_INFO";
const FALSE_TO_CHANGE_LOGO                      = "admin/FALSE_TO_CHANGE_LOGO";

const CHANGE_ALERT_MESSAGE                      = "admin/CHANGE_ALERT_MESSAGE";
const SET_ALERT_MESSAGE                         = "admin/SET_ALERT_MESSAGE";
const SET_ALERT_KIND_MESSAGE                    = "admin/SET_ALERT_KIND_MESSAGE";

export const getMyManageSubDomainList           = createRequestThunk(GET_MANAGE_SUB_DOMAIN_INFO, get_manage_sub_domain_list);

export const findUser                           = createRequestThunk(FIND_USER, search_user);

export const selectSubDomainInfo                = createAction(SELECT_SUB_DOMAIN_INFO);
export const selectUserInfo                     = createAction(SELECT_USER_INFO);

export const checkSubDomain                     = createRequestThunk(CHECK_SUB_DOMAIN, check_sub_domain);
export const duplicateCheckSubDomain            = createRequestThunk(CHECK_DUPLICATE_SUB_DOMAIN, check_sub_domain);
export const changeSubDomainLogo                = createRequestThunk(CHANGE_SUB_DOMAIN_LOGO, change_sub_domain_logo);
export const resetUserLoginStatus               = createRequestThunk(RESET_USER_LOGIN_STATUS, reset_user_login_status);
export const resetUserPW                        = createRequestThunk(RESET_USER_PW, reset_user_pw);

export const addSubDomainInfo                   = createRequestThunk(ADD_SUB_DOMAIN, add_sub_domain_info);
export const addSubDomainConfigAdmin            = createRequestThunk(ADD_SUB_DOMAIN_CONFIG_ADMIN, add_sub_domain_config_admin);
export const removeSubDomainConfigAdmin         = createRequestThunk(REMOVE_SUB_DOMAIN_CONFIG_ADMIN, remove_sub_domain_config_admin);
export const addSubDomainCreateAdmin            = createRequestThunk(ADD_SUB_DOMAIN_CREATE_ADMIN, add_sub_domain_create_admin);
export const removeSubDomainCreateAdmin         = createRequestThunk(REMOVE_SUB_DOMAIN_CREATE_ADMIN, remove_sub_domain_create_admin);

export const duplicateCheckUsers                = createRequestThunk(DUPLICATE_CHECK_USERS, duplicate_check_users);
export const createUsers                        = createRequestThunk(CREATE_USERS, create_users);

export const selectSubDomainConfigInfo          = createAction(SELECT_SUB_DOMAIN_CONFIG_INFO);
export const falseToChangeLogo                  = createAction(FALSE_TO_CHANGE_LOGO);

export const changeAlertMessage                 = (message, kind) => ({type : CHANGE_ALERT_MESSAGE, message, kind});
export const setAlertMessageString              = (message, kind) => ({type : SET_ALERT_KIND_MESSAGE, message, kind});
export const setMessageString                   = message => ({type : SET_ALERT_MESSAGE, message});

// * * * * * * * local server 관리용 * * * * * * * //
const CREATE_LOCAL_SERVER                       = "admin/CREATE_LOCAL_SERVER";
const CREATE_LOCAL_SERVER_SUCCESS               = "admin/CREATE_LOCAL_SERVER_SUCCESS";
const REMOVE_LOCAL_SERVER                       = "admin/REMOVE_LOCAL_SERVER";
const REMOVE_LOCAL_SERVER_SUCCESS               = "admin/REMOVE_LOCAL_SERVER_SUCCESS";

const GET_SUB_DOMAIN_LOCAL_SERVER_INFO          = "admin/GET_SUB_DOMAIN_LOCAL_SERVER_INFO";
const GET_SUB_DOMAIN_LOCAL_SERVER_INFO_SUCCESS  = "admin/GET_SUB_DOMAIN_LOCAL_SERVER_INFO_SUCCESS";
const GET_USER_LOCAL_SERVER_INFO                = "admin/GET_USER_LOCAL_SERVER_INFO";
const GET_USER_LOCAL_SERVER_INFO_SUCCESS        = "admin/GET_USER_LOCAL_SERVER_INFO_SUCCESS";
const CHANGE_LOCAL_SITE_INFO                    = "admin/CHANGE_LOCAL_SITE_INFO";
const CHANGE_LOCAL_SITE_INFO_SUCCESS            = "admin/CHANGE_LOCAL_SITE_INFO_SUCCESS";
// 20260828 로컬 서버 이름 인라인 수정 액션 추가
const CHANGE_LOCAL_SERVER_NAME                  = "admin/CHANGE_LOCAL_SERVER_NAME";
const CHANGE_LOCAL_SERVER_NAME_SUCCESS          = "admin/CHANGE_LOCAL_SERVER_NAME_SUCCESS";
const CHANGE_LOCAL_SERVER_PORT_INFO             = "admin/CHANGE_LOCAL_SERVER_PORT_INFO";
const CHANGE_LOCAL_SERVER_PORT_INFO_SUCCESS     = "admin/CHANGE_LOCAL_SERVER_PORT_INFO_SUCCESS";
// 260804 로컬서버 상세설정(로그인 허용/자동 로그인/업데이트 허용) 저장 액션 추가
const CHANGE_LOCAL_SERVER_CONFIG_INFO           = "admin/CHANGE_LOCAL_SERVER_CONFIG_INFO";
const CHANGE_LOCAL_SERVER_CONFIG_INFO_SUCCESS   = "admin/CHANGE_LOCAL_SERVER_CONFIG_INFO_SUCCESS";
// 20260814 클라우드 전용 로컬 서버 타입 기준정보 관리 액션을 추가한다.
const GET_LOCAL_SERVER_TYPES                    = "admin/GET_LOCAL_SERVER_TYPES";
const GET_LOCAL_SERVER_TYPES_SUCCESS            = "admin/GET_LOCAL_SERVER_TYPES_SUCCESS";
const UPDATE_LOCAL_SERVER_TYPE_USE              = "admin/UPDATE_LOCAL_SERVER_TYPE_USE";
const UPDATE_LOCAL_SERVER_TYPE_USE_SUCCESS      = "admin/UPDATE_LOCAL_SERVER_TYPE_USE_SUCCESS";
const UPDATE_LOCAL_SERVER_TYPES_USE             = "admin/UPDATE_LOCAL_SERVER_TYPES_USE";
const UPDATE_LOCAL_SERVER_TYPES_USE_SUCCESS     = "admin/UPDATE_LOCAL_SERVER_TYPES_USE_SUCCESS";
const GET_LOCAL_SERVER_COMMAND_INFO             = "admin/GET_LOCAL_SERVER_COMMAND_INFO";
const GET_LOCAL_SERVER_COMMAND_INFO_SUCCESS     = "admin/GET_LOCAL_SERVER_COMMAND_INFO_SUCCESS";
const SEND_LOCAL_SERVER_COMMAND                 = "admin/SEND_LOCAL_SERVER_COMMAND";
const SEND_LOCAL_SERVER_COMMAND_SUCCESS         = "admin/SEND_LOCAL_SERVER_COMMAND_SUCCESS";

const GET_LOCAL_SITE_LIST                       = "admin/GET_LOCAL_SITE_LIST";
const GET_LOCAL_SITE_LIST_SUCCESS               = "admin/GET_LOCAL_SITE_LIST_SUCCESS";
const CREATE_LOCAL_SITE                         = "admin/CREATE_LOCAL_SITE";
const CREATE_LOCAL_SITE_SUCCESS                 = "admin/CREATE_LOCAL_SITE_SUCCESS";
const DELETE_LOCAL_SITE                         = "admin/DELETE_LOCAL_SITE";
const DELETE_LOCAL_SITE_SUCCESS                 = "admin/DELETE_LOCAL_SITE_SUCCESS";
const CLASS_OPEN_ON_LOCAL_SITE                  = "admin/CLASS_OPEN_ON_LOCAL_SITE";
const CLASS_OPEN_ON_LOCAL_SITE_SUCCESS          = "admin/CLASS_OPEN_ON_LOCAL_SITE_SUCCESS";
const CLASS_CLOSE_ON_LOCAL_SITE                 = "admin/CLASS_CLOSE_ON_LOCAL_SITE";
const CLASS_CLOSE_ON_LOCAL_SITE_SUCCESS         = "admin/CLASS_CLOSE_ON_LOCAL_SITE_SUCCESS";
// 20260828 로컬 사이트 이름 인라인 수정 액션 추가
const CHANGE_LOCAL_SITE_NAME                    = "admin/CHANGE_LOCAL_SITE_NAME";
const CHANGE_LOCAL_SITE_NAME_SUCCESS            = "admin/CHANGE_LOCAL_SITE_NAME_SUCCESS";

const CLEAR_REMOTE_FORWARD_INFO                 = "admin/CLEAR_REMOTE_FORWARD_INFO";

export const createLocalServer                  = createRequestThunk(CREATE_LOCAL_SERVER, create_local_server);
export const removeLocalServer                  = createRequestThunk(REMOVE_LOCAL_SERVER, remove_local_server);
export const getSubDomainLocalServerList        = createRequestThunk(GET_SUB_DOMAIN_LOCAL_SERVER_INFO, get_sub_domain_local_server_info);
export const getUserLocalServerList             = createRequestThunk(GET_USER_LOCAL_SERVER_INFO, get_user_local_server_info);
export const changeLocalSiteInfo                = createRequestThunk(CHANGE_LOCAL_SITE_INFO, change_local_site_info);
// 20260828 로컬 서버 이름 인라인 수정
export const changeLocalServerName              = createRequestThunk(CHANGE_LOCAL_SERVER_NAME, change_local_server_name);
export const changeLocalServerPortInfo          = createRequestThunk(CHANGE_LOCAL_SERVER_PORT_INFO, change_local_server_port_info);
export const changeLocalServerConfigInfo        = createRequestThunk(CHANGE_LOCAL_SERVER_CONFIG_INFO, change_local_server_config_info);
export const getLocalServerTypes                = createRequestThunk(GET_LOCAL_SERVER_TYPES, get_local_server_types);
export const updateLocalServerTypeUse           = createRequestThunk(UPDATE_LOCAL_SERVER_TYPE_USE, update_local_server_type_use);
export const updateLocalServerTypesUse          = createRequestThunk(UPDATE_LOCAL_SERVER_TYPES_USE, update_local_server_types_use);
export const getLocalServerCommandInfo           = createRequestThunk(GET_LOCAL_SERVER_COMMAND_INFO, get_local_server_command_info);
export const sendLocalServerCommand              = createRequestThunk(SEND_LOCAL_SERVER_COMMAND, send_local_server_command);

export const getLocalSiteList                   = createRequestThunk(GET_LOCAL_SITE_LIST, get_local_site_list);
export const createLocalSite                    = createRequestThunk(CREATE_LOCAL_SITE, create_local_site);
export const deleteLocalSite                    = createRequestThunk(DELETE_LOCAL_SITE, delete_local_site);
// 20260828 로컬 사이트 이름 인라인 수정
export const changeLocalSiteName                = createRequestThunk(CHANGE_LOCAL_SITE_NAME, change_local_site_name);
export const classOpenOnLocalSite               = createRequestThunk(CLASS_OPEN_ON_LOCAL_SITE, class_open_on_local_site);
export const classCloseOnLocalSite              = createRequestThunk(CLASS_CLOSE_ON_LOCAL_SITE, class_close_on_local_site);

export const clearRemoteForwardInfo             = createAction(CLEAR_REMOTE_FORWARD_INFO);

// * * * * * * * ver.Lite local server 관리용 * * * * * * * //
const GET_LITE_SERVER_LIST                      = "admin/GET_LITE_SERVER_LIST";
const GET_LITE_SERVER_LIST_SUCCESS              = "admin/GET_LITE_SERVER_LIST_SUCCESS";

const CREATE_LITE_SERVER                        = "admin/CREATE_LITE_SERVER";
const CREATE_LITE_SERVER_SUCCESS                = "admin/CREATE_LITE_SERVER_SUCCESS";

const REMOVE_LITE_SERVER                        = "admin/REMOVE_LITE_SERVER";
const REMOVE_LITE_SERVER_SUCCESS                = "admin/REMOVE_LITE_SERVER_SUCCESS";

const CHANGE_LITE_SERVER_INFO                   = "admin/CHANGE_LITE_SERVER_INFO";
const CHANGE_LITE_SERVER_INFO_SUCCESS           = "admin/CHANGE_LITE_SERVER_INFO_SUCCESS";

export const createLiteServer                   = createRequestThunk(CREATE_LITE_SERVER, create_lite_server);
export const removeLiteServer                   = createRequestThunk(REMOVE_LITE_SERVER, remove_lite_server);
export const getLiteServerList                  = createRequestThunk(GET_LITE_SERVER_LIST, get_lite_server_list);
export const changeLiteServerInfo               = createRequestThunk(CHANGE_LITE_SERVER_INFO, change_lite_server_info);

// 260805 관리자 MEDIA 탭용 - 미디어 수프 게이트웨이 서버 전체 목록 관리
const GET_MEDIA_GATEWAY_LIST                    = "admin/GET_MEDIA_GATEWAY_LIST";
const GET_MEDIA_GATEWAY_LIST_SUCCESS            = "admin/GET_MEDIA_GATEWAY_LIST_SUCCESS";

export const getMediaGateWayList                = createRequestThunk(GET_MEDIA_GATEWAY_LIST, get_media_gateway_list);

// * * * * * * * 컨텐츠 선생님 관리 * * * * * * * //
const GET_ALL_CONTENT_TEACHERS          = "admin/GET_ALL_CONTENT_TEACHERS";
const GET_ALL_CONTENT_TEACHERS_SUCCESS  = "admin/GET_ALL_CONTENT_TEACHERS_SUCCESS";

const CREATE_CONTENT_TEACHERS           = "admin/CREATE_CONTENT_TEACHERS";
const CREATE_CONTENT_TEACHERS_SUCCESS   = "admin/CREATE_CONTENT_TEACHERS_SUCCESS";

const UPDATE_TEACHER_USE_YN             = "admin/UPDATE_TEACHER_USE_YN";
const UPDATE_TEACHER_USE_YN_SUCCESS     = "admin/UPDATE_TEACHER_USE_YN_SUCCESS";

const UPDATE_TEACHER_NAME               = "admin/UPDATE_TEACHER_NAME";
const UPDATE_TEACHER_NAME_SUCCESS       = "admin/UPDATE_TEACHER_NAME_SUCCESS";

const UPDATE_TEACHER_INFO               = "admin/UPDATE_TEACHER_INFO";
const UPDATE_TEACHER_INFO_SUCCESS       = "admin/UPDATE_TEACHER_INFO_SUCCESS";

const DELETE_CONTENT_TEACHER            = "admin/DELETE_CONTENT_TEACHER";
const DELETE_CONTENT_TEACHER_SUCCESS    = "admin/DELETE_CONTENT_TEACHER_SUCCESS";

export const getAllContentTeachers      = createRequestThunk(GET_ALL_CONTENT_TEACHERS, get_all_content_teachers);
export const createContentTeachers      = createRequestThunk(CREATE_CONTENT_TEACHERS, create_content_teachers);
export const updateTeacherUseYn         = createRequestThunk(UPDATE_TEACHER_USE_YN, update_content_teacher_use_yn);
export const updateTeacherName          = createRequestThunk(UPDATE_TEACHER_NAME, update_content_teacher_name);
export const updateTeacherInfo          = createRequestThunk(UPDATE_TEACHER_INFO, update_content_teacher_info);
export const deleteContentTeacher       = createRequestThunk(DELETE_CONTENT_TEACHER, delete_content_teacher);

// * * * * * * * 클래스 관리 * * * * * * * //
const GET_ALL_LIVE_LIST             = "admin/GET_ALL_LIVE_LIST";
const GET_ALL_LIVE_LIST_SUCCESS     = "admin/GET_ALL_LIVE_LIST_SUCCESS";

const UPDATE_LIVE_INFO              = "admin/UPDATE_LIVE_INFO";
const UPDATE_LIVE_INFO_SUCCESS      = "admin/UPDATE_LIVE_INFO_SUCCESS";

const DELETE_LIVE                   = "admin/DELETE_LIVE";
const DELETE_LIVE_SUCCESS           = "admin/DELETE_LIVE_SUCCESS";

export const getAllLiveList         = createRequestThunk(GET_ALL_LIVE_LIST, get_all_live_list);
export const updateLiveInfo         = createRequestThunk(UPDATE_LIVE_INFO, update_live_info);
export const deleteLive             = createRequestThunk(DELETE_LIVE, delete_live);

// * * * * * * * 고정 URL 관리 (CONTENT_URL_INFO) * * * * * * * //
const GET_ALL_CONTENT_URLS          = "admin/GET_ALL_CONTENT_URLS";
const GET_ALL_CONTENT_URLS_SUCCESS  = "admin/GET_ALL_CONTENT_URLS_SUCCESS";

const CREATE_CONTENT_URLS           = "admin/CREATE_CONTENT_URLS";
const CREATE_CONTENT_URLS_SUCCESS   = "admin/CREATE_CONTENT_URLS_SUCCESS";

const UPDATE_URL_INFO               = "admin/UPDATE_URL_INFO";
const UPDATE_URL_INFO_SUCCESS       = "admin/UPDATE_URL_INFO_SUCCESS";

const DELETE_CONTENT_URL            = "admin/DELETE_CONTENT_URL";
const DELETE_CONTENT_URL_SUCCESS    = "admin/DELETE_CONTENT_URL_SUCCESS";

export const getAllContentUrls      = createRequestThunk(GET_ALL_CONTENT_URLS, get_all_content_urls);
export const createContentUrls      = createRequestThunk(CREATE_CONTENT_URLS, create_content_urls);
export const updateUrlInfo          = createRequestThunk(UPDATE_URL_INFO, update_content_url_info);
export const deleteContentUrl       = createRequestThunk(DELETE_CONTENT_URL, delete_content_url);

// * * * * * * * MQ function * * * * * * * //
const MQ_MEDIA_SERVER_INFO                      = "admin/MQ_MEDIA_SERVER_INFO";
const MQ_RCV_REMOTE_FORWARD_RESULT              = "admin/MQ_RCV_REMOTE_FORWARD_RESULT";
const MQ_RCV_LOCAL_SERVER_COMMAND_ACK           = "admin/MQ_RCV_LOCAL_SERVER_COMMAND_ACK";

export const mqRcvMediaInfo                     = createAction(MQ_MEDIA_SERVER_INFO);
export const mqRcvRemoteForwardResult           = createAction(MQ_RCV_REMOTE_FORWARD_RESULT);
// 20260828 로컬 서버 명령 capability ACK를 관리자 카드 상태에 반영한다.
export const mqRcvLocalServerCommandAck          = createAction(MQ_RCV_LOCAL_SERVER_COMMAND_ACK);

const initialState = {
    list_configSubDomain        : [],
    list_createSubDomain        : [],
    list_configLocalServer      : [],
    // 20260814 생성·상세설정·타입 관리 영역에서 공통으로 사용하는 서버 타입 목록이다.
    list_localServerType        : [],
    // 260804 로컬 서버 신규 등록 시 목록에서 자동으로 페이지 이동시키기 위한 식별자
    lastCreatedLocalServerSeq   : -1,
    list_configLiteServer       : [],
    list_configLocalSite        : [],

    list_localSite              : [], // 로컬서버 정보 변경할 때 보여줄 간단한 local site 목록 ...23.11.09 by ykhan

    media_info                  : null,
    // 260805 관리자 MEDIA 탭용 - 미디어 수프 게이트웨이 서버 전체 목록 (활성/비활성 포함)
    list_mediaGateWay           : [],

    searchResult                : [],

    selectedUserInfo            : {
        userSeq                 : -1,
        userID                  : "",
        userNickname            : "",
    },
    selectedSubDomainInfo       : {
        selectedIdx             : 0,
        subDomainSeq            : -1,
        subDomainName           : i18n.t("서브_도메인_없음", { ns: "admin" })
    },

    isStandardType              : false,
    isCheckedSubDomain          : false,
    isCorrectSubDomain          : false,

    isCheckSubDomainOK          : false,
    isAddSubDomainOK            : false,
    isChangeLogoOK              : false,

    alertKind                   : ConstData.ALERT_KIND.NONE,
    alertMessage                : "",
    // 20260814 로컬 서버 페이지에서 같은 문구도 반복 표시하고 대상 패널을 구분한다.
    localServerAlertEventId     : 0,
    localServerAlertTarget      : null,

    /** 로컬 서버 포트 관련 정보 기본값 추가 ... by hjkim 20251223 */
    remoteForwardResult         : {
        success                 : null,
        localServerSeq          : -1,
        localPort               : -1,
        message                 : null,
        timestamp               : null,
        alertKind               : ConstData.ALERT_KIND.NONE,
        alertMessage            : null
    },

    /** 컨텐츠 선생님 목록 관리 ... by hjkim 20260612 */
    list_contentTeacher         : [],
    isNeedTeacherRefresh        : false,

    /** 관리자용 라이브 목록 ... by hjkim 20260612 */
    list_adminLive              : [],
    isNeedClassRefresh          : false,

    /** 고정 URL 목록 관리 20260615 */
    list_contentUrl             : [],
    isNeedUrlRefresh            : false,
};

const admin = handleActions({
    // 20261023 초기화 완료 서버만 즉시 갱신하고 기존 이력과 코덱 상태는 보존한다.
    "admin/REPORT_TOKEN_RESET_COMPLETED": (state, { payload }) => ({ ...state,
        list_configLocalServer: state.list_configLocalServer.map(info => Number(info.localServerSeq) === Number(payload.localServerSeq)
            ? { ...info, reportTokenIssuedYn: "N", reportTokenIssuedDt: null, reportTokenVerifiedDt: null,
                tokenResetRequestYn: "N", tokenResetRequestDt: null, tokenResetReason: null } : info) }),
    [SUB_DOMAIN_STATE_INIT]: (state, action) => {
        const { isSuccessed } = action.payload;
        //console.log("SUB_DOMAIN_STATE_INIT - ", action.payload);

        if (isSuccessed) {
            const { isLogoutSuccess } = action.payload;

            if (isLogoutSuccess) {
                return {
                    ...state,
                    list_configSubDomain    : [],
                    list_createSubDomain    : [],

                    selectedUserInfo        : {
                        userSeq             : -1,
                        userID              : "",
                        userNickname        : ""
                    },
                    selectedSubDomainInfo   : {
                        selectedIdx         : 0,
                        subDomainSeq        : -1,
                        subDomainName       : i18n.t("서브_도메인_없음", { ns: "admin" })
                    },

                    isCheckedSubDomain      : false,
                    isCorrectSubDomain      : false,

                    isCheckSubDomainOK      : false,
                    isAddSubDomainOK        : false,
                    isChangeLogoOK          : false,

                    alertKind               : ConstData.ALERT_KIND.NONE,
                    alertMessage            : ""
                }
            }
        } else {
            console.log("SUB_DOMAIN_STATE_INIT - isSuccessed => ", isSuccessed);

            return {
                ...state
            }
        }
    },

    [SUB_DOMAIN_INFO_INIT]: (state, action) => {
        const { isSuccessed } = action.payload;
        //console.log("SUB_DOMAIN_INFO_INIT - ", action.payload);

        if (isSuccessed) {
            const { list_configSubDomain, list_createSubDomain } = action.payload;
            let clist_configSubDomain = [];
            let clist_createSubDomain = [];
            let selConfigSubDomainInfo = {
                selectedIdx     : 0,
                subDomainSeq    : -1,
                subDomainName   : i18n.t("서브_도메인_없음", { ns: "admin" })
            };

            if (list_configSubDomain && list_configSubDomain.length > 0) {
                clist_configSubDomain = list_configSubDomain.map(row => ({
                    subDomainSeq    : row.SUB_DOMAIN_SEQ,
                    subDomainName   : row.SUB_DOMAIN_NM,
                    chatRoomCnt     : row.CT_ROOM_CNT,
                    liveCnt         : row.LIVE_CNT,
                    liveOnCnt       : row.LIVE_ON_CNT,
                    list_member     : row.list_member === undefined || row.list_member === null ? 
                                      [] : 
                                      row.list_member.map(memRow => ({
                                        userSeq       : memRow.USER_SEQ,
                                        userID        : memRow.USER_ID,
                                        userNickname  : memRow.USER_NICKNAME,
                                        userProfile   : memRow.USER_PROFILE,
                                        profileImgUrl : memRow.USER_PROFILE_IMG,
                                        userStatus    : memRow.MEMBER_STATUS,
                                        webUserStatus : memRow.WEB_MEMBER_STATUS,
                                        userLoginDT   : memRow.USER_LOGIN_DT,
                                        userSignUpDT  : memRow.USER_SIGNUP_DT, 
                                        isConfigAdmin : memRow.CONFIG_ADMIN_YN === "Y" ? true : false,
                                        isCreateAdmin : memRow.CREATE_ADMIN_YN === "Y" ? true : false,
                                      }))
                }));
            }

            if (list_createSubDomain && list_createSubDomain.length > 0) {
                clist_createSubDomain = list_createSubDomain.map(row => ({
                    subDomainSeq    : row.SUB_DOMAIN_SEQ,
                    subDomainName   : row.SUB_DOMAIN_NM,
                    memberCnt       : row.MEMBER_CNT,
                    chatRoomCnt     : row.CT_ROOM_CNT,
                    liveCnt         : row.LIVE_CNT,
                    liveOnCnt       : row.LIVE_ON_CNT,
                }));
            }

            if (clist_configSubDomain.length > 0) {
                selConfigSubDomainInfo = {
                    selectedIdx     : 0,
                    subDomainSeq    : clist_configSubDomain[0].subDomainSeq,
                    subDomainName   : clist_configSubDomain[0].subDomainName
                };
            }

            return {
                ...state,
                list_configSubDomain    : clist_configSubDomain,
                list_createSubDomain    : clist_createSubDomain,
                selectedSubDomainInfo   : selConfigSubDomainInfo,
            }
        } else {
            console.log("SUB_DOMAIN_INFO_INIT - isSuccessed => ", isSuccessed);

            return {
                ...state,
                selectedSubDomainInfo   : {
                    selectedIdx         : 0,
                    subDomainSeq        : -1,
                    subDomainName       : i18n.t("서브_도메인_없음", { ns: "admin" })
                },
                list_configSubDomain    : [],
                list_createSubDomain    : []
            }
        }
    },

    // for sub domain admin
    [GET_MANAGE_SUB_DOMAIN_INFO_SUCCESS]: (state, action) => {
        const { isSuccessed } = action.payload;
        //console.log("GET_MANAGE_SUB_DOMAIN_INFO - ", action.payload);

        if (isSuccessed) {
            const { list_configSubDomain, list_createSubDomain } = action.payload;
            let clist_configSubDomain = [];
            let clist_createSubDomain = [];
            let selConfigSubDomainInfo = {
                selectedIdx     : 0,
                subDomainSeq    : -1,
                subDomainName   : i18n.t("서브_도메인_없음", { ns: "admin" })
            };

            if (list_configSubDomain && list_configSubDomain.length > 0) {
                clist_configSubDomain = list_configSubDomain.map(row => ({
                    subDomainSeq    : row.SUB_DOMAIN_SEQ,
                    subDomainName   : row.SUB_DOMAIN_NM,
                    chatRoomCnt     : row.CT_ROOM_CNT,
                    liveCnt         : row.LIVE_CNT,
                    liveOnCnt       : row.LIVE_ON_CNT,
                    list_member     : row.list_member === undefined || row.list_member === null ? 
                                      [] : 
                                      row.list_member.map(memRow => ({
                                        userSeq         : memRow.USER_SEQ,
                                        userID          : memRow.USER_ID,
                                        userNickname    : memRow.USER_NICKNAME,
                                        userProfile     : memRow.USER_PROFILE,
                                        profileImgUrl   : memRow.USER_PROFILE_IMG,
                                        userStatus      : memRow.MEMBER_STATUS,
                                        webUserStatus   : memRow.WEB_MEMBER_STATUS,
                                        userLoginDT     : memRow.USER_LOGIN_DT,
                                        userSignUpDT    : memRow.USER_SIGNUP_DT, 
                                        isConfigAdmin   : memRow.CONFIG_ADMIN_YN === "Y" ? true : false,
                                        isCreateAdmin   : memRow.CREATE_ADMIN_YN === "Y" ? true : false,
                                      }))
                }));
            }

            if (list_createSubDomain && list_createSubDomain.length > 0) {
                clist_createSubDomain = list_createSubDomain.map(row => ({
                    subDomainSeq    : row.SUB_DOMAIN_SEQ,
                    subDomainName   : row.SUB_DOMAIN_NM,
                    memberCnt       : row.MEMBER_CNT,
                    chatRoomCnt     : row.CT_ROOM_CNT,
                    liveCnt         : row.LIVE_CNT,
                    liveOnCnt       : row.LIVE_ON_CNT,
                }));
            }

            if (clist_configSubDomain.length > 0) {
                selConfigSubDomainInfo = {
                    selectedIdx     : 0,
                    subDomainSeq    : clist_configSubDomain[0].subDomainSeq,
                    subDomainName   : clist_configSubDomain[0].subDomainName
                };
            }

            return {
                ...state,
                list_configSubDomain    : clist_configSubDomain,
                list_createSubDomain    : clist_createSubDomain,
                selectedSubDomainInfo   : selConfigSubDomainInfo,
                isChangeLogoOK          : false,
                alertMessage            : "",
                alertKind               : ConstData.ALERT_KIND.NONE,
            }
        } else {
            console.log("GET_MANAGE_SUB_DOMAIN_INFO - isSuccessed => ", isSuccessed);

            return {
                ...state,
                list_configSubDomain    : [],
                list_createSubDomain    : [],
                selectedSubDomainInfo   : {
                    selectedIdx         : 0,
                    subDomainSeq        : -1,
                    subDomainName       : i18n.t("서브_도메인_없음", { ns: "admin" })
                },
                isChangeLogoOK          : false,
                alertKind               : ConstData.ALERT_KIND.NONE,
                alertMessage            : ""
            }
        }
    },

    [FIND_USER_SUCCESS]: (state, action) => {
        const { isSuccessed } = action.payload;
        //console.log("FIND_USER_SUCCESS - ", action.payload);

        if (isSuccessed) {
            const { list_user } = action.payload;
            let clist_user = [];

            if (list_user && list_user.length > 0) {
                clist_user = list_user.map(row => ({
                    userSeq         : row.USER_SEQ,
                    userID          : row.USER_ID,
                    userNickname    : row.USER_NICKNAME,
                    userProfile     : row.USER_PROFILE,
                    profileImgUrl   : row.USER_PROFILE_IMG
                }));
            }

            return {
                ...state,
                searchResult        : clist_user
            }
        } else {
            console.log("FIND_USER_SUCCESS - isSuccessed => ", isSuccessed);

            return {
                ...state
            }
        }
    },

    [SELECT_SUB_DOMAIN_INFO]: (state, action) => {
        const { userKind, subDomainSeq } = action.payload;
        //console.log("SELECT_SUB_DOMAIN_INFO - ", action.payload);

        let select_sub_domain_info = {
            selectedIdx     : 0,
            subDomainSeq    : -1,
            subDomainName   : ""
        };

        if (userKind === "hiclasstv") {
            const subDomain_info = state.list_configSubDomain.find(info => info.subDomainSeq === subDomainSeq);
            if (subDomain_info) {
                select_sub_domain_info = {
                    selectedIdx         : state.list_configSubDomain.indexOf(subDomain_info),
                    subDomainSeq        : subDomain_info.subDomainSeq,
                    subDomainName       : subDomain_info.subDomainName
                };
            }
        } else {
            const subDomain_info = state.list_createSubDomain.find(info => info.subDomainSeq === subDomainSeq);
            if (subDomain_info) {
                select_sub_domain_info = {
                    selectedIdx         : state.list_createSubDomain.indexOf(subDomain_info),
                    subDomainSeq        : subDomain_info.subDomainSeq,
                    subDomainName       : subDomain_info.subDomainName
                };
            }
        }

        return {
            ...state,
            selectedSubDomainInfo       : select_sub_domain_info
        }
    },

    [SELECT_USER_INFO]: (state, action) => {
        const { subDomainSeq, selUserSeq } = action.payload;
        //console.log("SELECT_USER_INFO - ", action.payload);

        let select_user_info = {
            userSeq         : -1,
            userID          : "",
            userNickname    : ""
        };

        const subDomain_info = state.list_configSubDomain.find(info => info.subDomainSeq === subDomainSeq);
        if (subDomain_info) {
            if (subDomain_info.list_member) {
                const user_info = subDomain_info.list_member.find(info => info.userSeq === selUserSeq);
                if (user_info) {
                    select_user_info = {
                        userSeq         : user_info.userSeq,
                        userID          : user_info.userID,
                        userNickname    : user_info.userNickname
                    };
                }
            }
        }

        return {
            ...state,
            selectedUserInfo : select_user_info
        }
    },

    [ADD_SUB_DOMAIN_SUCCESS]: (state, action) => {
        const { subDomainName } = action.parms;
        const { isSuccessed } = action.payload;
        //console.log("ADD_SUB_DOMAIN_SUCCESS - ", action.payload, action.parms);

        if (isSuccessed) {
            const { isAddSuccess } = action.payload;

            if (isAddSuccess) {
                const { isAdminUpdateSuccess, subDomainSEQ } = action.payload;

                if (isAdminUpdateSuccess) {
                    if (subDomainSEQ >= 0) {
                        const newSubDomain_info = {
                            subDomainSeq    : subDomainSEQ,
                            subDomainName   : subDomainName,
                            chatRoomCnt     : 0, 
                            liveCnt         : 0,
                            liveOnCnt       : 0
                        };

                        return {
                            ...state,
                            list_createSubDomain    : state.list_createSubDomain.concat(newSubDomain_info),
                            isAddSubDomainOK        : true,
                            isCheckSubDomainOK      : false,
                            alertKind               : ConstData.ALERT_KIND.SUCCESS,
                            alertMessage            : i18n.t("서브_도메인_등록_성공", { ns: "admin" })
                        }
                    } else {
                        console.log("ADD_SUB_DOMAIN - subDomainSEQ => ", subDomainSEQ);

                        return {
                            ...state,
                            isAddSubDomainOK        : false,
                            alertKind               : ConstData.ALERT_KIND.DANGER,
                            alertMessage            : i18n.t("서브_도메인_등록_실패", { ns: "admin" }) + " (Code.201)"
                        }
                    }
                } else {
                    console.log("ADD_SUB_DOMAIN - isAdminUpdateSuccess, subDomainSEQ => ", action.payload);

                    return {
                        ...state,
                        isAddSubDomainOK        : false,
                        alertKind               : ConstData.ALERT_KIND.DANGER,
                        alertMessage            : i18n.t("서브_도메인_관리자_지정_실패", { ns: "admin" }) + " (Code.203)"
                    }
                }
            } else {
                console.log("ADD_SUB_DOMAIN - isAddSuccess => ", isAddSuccess);

                return {
                    ...state,
                    isAddSubDomainOK        : false, 
                    alertKind               : ConstData.ALERT_KIND.DANGER,
                    alertMessage            : i18n.t("서브_도메인_등록_실패", { ns: "admin" }) + " (Code.202)"
                }
            }
        } else {
            console.log("ADD_SUB_DOMAIN - isSuccessed => ", isSuccessed);

            return {
                ...state,
                isAddSubDomainOK    : false, 
                alertKind           : ConstData.ALERT_KIND.DANGER,
                alertMessage        : i18n.t("서브_도메인_등록_요청_실패", { ns: "admin" }) + " (Code.200)"
            }
        }
    },

    [CHANGE_SUB_DOMAIN_LOGO_SUCCESS]: (state, action) => {
        //const { subDomainSeq } = action.parms;
        const { isSuccessed } = action.payload;
        //console.log("CHANGE_SUB_DOMAIN_LOGO - ", action.payload, action.parms);

        if (isSuccessed) {
            const { isUploadSuccess } = action.payload;

            if (isUploadSuccess) {
                return {
                    ...state,
                    isChangeLogoOK   : true,
                    alertKind        : ConstData.ALERT_KIND.SUCCESS,
                    alertMessage     : i18n.t("서브_도메인_로고_변경_성공", { ns: "admin" })
                }
            } else {
                console.log("CHANGE_SUB_DOMAIN_LOGO - isUploadSuccess => ", isUploadSuccess);

                return {
                    ...state,
                    isChangeLogoOK   : false,
                    alertKind        : ConstData.ALERT_KIND.DANGER,
                    alertMessage     : i18n.t("서브_도메인_로고_변경_실패", { ns: "admin" }) + " (Code.212)"
                }
            }
        } else {
            console.log("CHANGE_SUB_DOMAIN_LOGO - isSuccessed => ", isSuccessed);

            return {
                ...state,
                isChangeLogoOK   : false,
                alertKind        : ConstData.ALERT_KIND.DANGER,
                alertMessage     : i18n.t("서브_도메인_로고_변경_요청_실패", { ns: "admin" }) + " (Code.213)"
            }
        }
    },

    [SELECT_SUB_DOMAIN_CONFIG_INFO]: (state, action) => {
        const { subDomain_info } = action.payload;
        //console.log("SELECT_SUB_DOMAIN_CONFIG_INFO - ", action.payload);

        if (subDomain_info) {
            return {
                ...state,
                selectedSubDomainInfo   : subDomain_info
            }
        } else {
            return {
                ...state
            }
        }
    },

    [FALSE_TO_CHANGE_LOGO]: (state, action) => {
        //console.log("FALSE_TO_CHANGE_LOGO - ");

        return {
            ...state,
            isChangeLogoOK : false
        }
    },

    // sub domain check
    [CHECK_SUB_DOMAIN_SUCCESS]: (state, action) => {
        const { isSuccessed } = action.payload;
        //console.log("CHECK_SUB_DOMAIN_SUCCESS - ", action.payload);

        if (isSuccessed) {
            const { isExist, isStandardType } = action.payload;

            if (isExist) {
                return {
                    ...state, 
                    isCheckedSubDomain  : true,
                    isCorrectSubDomain  : true,
                    isStandardType      : isStandardType
                }
            } else {
                //console.log("CHECK_SUB_DOMAIN - isExist => ", isExist);

                return {
                    ...state,
                    isCheckedSubDomain  : true,
                    isCorrectSubDomain  : false,
                    isStandardType      : isStandardType
                }
            }
        } else {
            //console.log("CHECK_SUB_DOMAIN - isSuccessed => ", isSuccessed);

            return {
                ...state,
                isCheckedSubDomain  : true,
                isCorrectSubDomain  : false
            }
        }
    },

    [CHECK_DUPLICATE_SUB_DOMAIN_SUCCESS]: (state, action) => {
        const { isSuccessed } = action.payload;
        //console.log("CHECK_DUPLICATE_SUB_DOMAIN_SUCCESS - ", action.payload);

        if (isSuccessed) {
            const { isExist } = action.payload;

            if (isExist) {
                return {
                    ...state,
                    isCheckSubDomainOK      : false, 
                    alertKind               : ConstData.ALERT_KIND.DANGER,
                    alertMessage            : i18n.t("서브_도메인명_사용_불가능", { ns: "admin" })
                }
            } else {
                return {
                    ...state,
                    isCheckSubDomainOK      : true, 
                    alertKind               : ConstData.ALERT_KIND.SUCCESS,
                    alertMessage            : i18n.t("서브_도메인명_사용_가능", { ns: "admin" })
                }
            }
        } else {
            console.log("CHECK_DUPLICATE_SUB_DOMAIN - isSuccessed => ", isSuccessed);

            return {
                ...state,
                isCheckSubDomainOK      : false, 
                alertKind               : ConstData.ALERT_KIND.DANGER,
                alertMessage            : i18n.t("서브_도메인명_확인_요청_실패", { ns: "admin" }) + " (Code.250)"
            }
        }
    },

    [RESET_USER_LOGIN_STATUS_SUCCESS]: (state, action) => {
        const { mode, subDomainSeq, selectedUserSeq } = action.parms;
        const { isSuccessed } = action.payload;
        //console.log("RESET_USER_LOGIN_STATUS_SUCCESS - ", action.payload, action.parms);

        if (isSuccessed) {
            const { isResetSuccess } = action.payload;

            if (isResetSuccess) {
                return produce (state, draft => {
                    const subDomain_info = draft.list_configSubDomain.find(info => info.subDomainSeq === subDomainSeq);
                    if (subDomain_info) {
                        if (subDomain_info.list_member) {
                            const member_info = subDomain_info.list_member.find(info => info.userSeq === selectedUserSeq);
                            if (member_info) {
                                if (mode === "web") {
                                    member_info.webUserStatus = ConstData.LOGIN_STATUS.LOG_OUT;
                                } else if (mode === "hiclass") {
                                    member_info.userStatus = ConstData.LOGIN_STATUS.LOG_OUT;
                                } else {
                                    console.log("RESET_USER_LOGIN_STATUS - mode => ", mode);
                                }
                            }
                        }
                    }
                });
            } else {
                console.log("RESET_USER_LOGIN_STATUS - isResetSuccess => ", isResetSuccess);

                return {
                    ...state,
                    alertKind        : ConstData.ALERT_KIND.DANGER,
                    alertMessage     : i18n.t("멤버_상태_초기화_실패", { ns: "admin" }) + " (Code.301)"
                }
            }
        } else {
            console.log("RESET_USER_LOGIN_STATUS - isSuccessed => ", isSuccessed);

            return {
                ...state,
                alertKind        : ConstData.ALERT_KIND.DANGER,
                alertMessage     : i18n.t("멤버_상태_초기화_요청_실패", { ns: "admin" }) + " (Code.300)"
            }
        }
    },

    [RESET_USER_PW_SUCCESS]: (state, action) => {
        const { isSuccessed } = action.payload;
        //console.log("RESET_USER_PW_SUCCESS - ", action.payload);

        if (isSuccessed) {
            const { isResetSuccess } = action.payload;

            if (isResetSuccess) {
                return {
                    ...state,
                    alertKind        : ConstData.ALERT_KIND.SUCCESS,
                    alertMessage     : i18n.t("멤버_비밀번호_초기화_성공", { ns: "admin" })
                }
            } else {
                console.log("RESET_USER_PW_SUCCESS - isResetSuccess => ", isResetSuccess);

                return {
                    ...state,
                    alertKind        : ConstData.ALERT_KIND.DANGER,
                    alertMessage     : i18n.t("멤버_비밀번호_초기화_실패", { ns: "admin" }) + " (Code.303)"
                }
            }
        } else {
            console.log("RESET_USER_PW_SUCCESS - isSuccessed => ", isSuccessed);

            return {
                ...state,
                alertKind        : ConstData.ALERT_KIND.DANGER,
                alertMessage     : i18n.t("멤버_비밀번호_초기화_요청_실패", { ns: "admin" }) + " (Code.302)"
            }
        }
    },

    [ADD_SUB_DOMAIN_CONFIG_ADMIN_SUCCESS]: (state, action) => {
        const { subDomainSeq, selectedUserSeq } = action.parms;
        const { isSuccessed } = action.payload;
        //console.log("ADD_SUB_DOMAIN_CONFIG_ADMIN_SUCCESS - ", action.payload, action.parms);

        if (isSuccessed) {
            const { isAddSuccess } = action.payload;

            if (isAddSuccess) {
                return produce (state, draft => {
                    const subDomain_info = draft.list_configSubDomain.find(info => info.subDomainSeq === subDomainSeq);
                    if (subDomain_info) {
                        if (subDomain_info.list_member) {
                            const member_info = subDomain_info.list_member.find(info => info.userSeq === selectedUserSeq);
                            if (member_info) {
                                member_info.isConfigAdmin = true;
                                console.log(i18n.t("서브_도메인_관리자_지정_성공", { ns: "admin" }));
                            }
                        }
                    }
                });
            } else {
                console.log("ADD_SUB_DOMAIN_CONFIG_ADMIN - isAddSuccess => ", isAddSuccess);

                return {
                    ...state,
                    alertKind        : ConstData.ALERT_KIND.DANGER,
                    alertMessage     : i18n.t("서브_도메인_관리자_지정_실패", { ns: "admin" }) + " (Code.204)"
                }
            }
        } else {
            console.log("ADD_SUB_DOMAIN_CONFIG_ADMIN - isSuccessed => ", isSuccessed);

            return {
                ...state,
                alertKind        : ConstData.ALERT_KIND.DANGER,
                alertMessage     : i18n.t("서브_도메인_관리자_지정_요청_실패", { ns: "admin" }) + " (Code.205)"
            }
        }
    },

    [REMOVE_SUB_DOMAIN_CONFIG_ADMIN_SUCCESS]: (state, action) => {
        const { subDomainSeq, selectedUserSeq } = action.parms;
        const { isSuccessed } = action.payload;
        //console.log("REMOVE_SUB_DOMAIN_CONFIG_ADMIN_SUCCESS - ", action.payload, action.parms);

        if (isSuccessed) {
            const { isRemoveSuccess } = action.payload;

            if (isRemoveSuccess) {
                return produce (state, draft => {
                    const subDomain_info = draft.list_configSubDomain.find(info => info.subDomainSeq === subDomainSeq);
                    if (subDomain_info) {
                        if (subDomain_info.list_member) {
                            const member_info = subDomain_info.list_member.find(info => info.userSeq === selectedUserSeq);
                            if (member_info) {
                                member_info.isConfigAdmin = false;
                                console.log(i18n.t("서브_도메인_관리자_해제_성공", { ns: "admin" }));
                            }
                        }
                    }
                });
            } else {
                console.log("REMOVE_SUB_DOMAIN_CONFIG_ADMIN - isRemoveSuccess => ", isRemoveSuccess);

                return {
                    ...state,
                    alertKind        : ConstData.ALERT_KIND.DANGER,
                    alertMessage     : i18n.t("서브_도메인_관리자_해제_실패", { ns: "admin" }) + " (Code.207)"
                }
            }
        } else {
            console.log("REMOVE_SUB_DOMAIN_CONFIG_ADMIN - isSuccessed => ", isSuccessed);

            return {
                ...state,
                alertKind        : ConstData.ALERT_KIND.DANGER,
                alertMessage     : i18n.t("서브_도메인_관리자_해제_요청_실패", { ns: "admin" }) + " (Code.206)"
            }
        }
    },

    [ADD_SUB_DOMAIN_CREATE_ADMIN_SUCCESS]: (state, action) => {
        const { subDomainSeq, selectedUserSeq } = action.parms;
        const { isSuccessed } = action.payload;
        //console.log("ADD_SUB_DOMAIN_CREATE_ADMIN_SUCCESS - ", action.payload, action.parms);

        if (isSuccessed) {
            const { isAddSuccess } = action.payload;

            if (isAddSuccess) {
                return produce (state, draft => {
                    const subDomain_info = draft.list_configSubDomain.find(info => info.subDomainSeq === subDomainSeq);
                    if (subDomain_info) {
                        if (subDomain_info.list_member) {
                            const member_info = subDomain_info.list_member.find(info => info.userSeq === selectedUserSeq);
                            if (member_info) {
                                member_info.isCreateAdmin = true;
                            }
                        }
                    }
                });
            } else {
                console.log("ADD_SUB_DOMAIN_CREATE_ADMIN - isAddSuccess => ", isAddSuccess);

                return {
                    ...state,
                    alertKind        : ConstData.ALERT_KIND.DANGER,
                    alertMessage     : i18n.t("서브_도메인_추가_권한_부여_실패", { ns: "admin" }) + " (Code.208)"
                }
            }
        } else {
            console.log("ADD_SUB_DOMAIN_CREATE_ADMIN - isSuccessed => ", isSuccessed);

            return {
                ...state,
                alertKind        : ConstData.ALERT_KIND.DANGER,
                alertMessage     : i18n.t("서브_도메인_추가_권한_부여_요청_실패", { ns: "admin" }) + " (Code.209)"
            }
        }
    },

    [REMOVE_SUB_DOMAIN_CREATE_ADMIN_SUCCESS]: (state, action) => {
        const { subDomainSeq, selectedUserSeq } = action.parms;
        const { isSuccessed } = action.payload;
        //console.log("REMOVE_SUB_DOMAIN_CREATE_ADMIN_SUCCESS - ", action.payload, action.parms);

        if (isSuccessed) {
            const { isRemoveSuccess } = action.payload;

            if (isRemoveSuccess) {
                return produce (state, draft => {
                    const subDomain_info = draft.list_configSubDomain.find(info => info.subDomainSeq === subDomainSeq);
                    if (subDomain_info) {
                        if (subDomain_info.list_member) {
                            const member_info = subDomain_info.list_member.find(info => info.userSeq === selectedUserSeq);
                            if (member_info) {
                                member_info.isCreateAdmin = false;
                            }
                        }
                    }
                });
            } else {
                console.log("REMOVE_SUB_DOMAIN_CREATE_ADMIN - isRemoveSuccess => ", isRemoveSuccess);

                return {
                    ...state,
                    alertKind        : ConstData.ALERT_KIND.DANGER,
                    alertMessage     : i18n.t("서브_도메인_추가_권한_해제_실패", { ns: "admin" }) + " (Code.210)"
                }
            }
        } else {
            console.log("REMOVE_SUB_DOMAIN_CREATE_ADMIN - isSuccessed => ", isSuccessed);

            return {
                ...state,
                alertKind        : ConstData.ALERT_KIND.DANGER,
                alertMessage     : i18n.t("서브_도메인_추가_권한_해제_요청_실패", { ns: "admin" }) + " (Code.211)"
            }
        }
    },

    [DUPLICATE_CHECK_USERS_SUCCESS]: (state, action) => {
        const { subDomainSeq, list_createUser } = action.parms;
        const { isSuccessed } = action.payload;
        console.log("DUPLICATE_CHECK_USERS - ", action.payload);

        if (isSuccessed) {
            const { list_results } = action.payload;

            if (list_results) {
                return produce (state, draft => {
                    const subDomain_info = draft.list_configSubDomain.find(info => info.subDomainSeq === subDomainSeq);
                    if (subDomain_info) {
                        subDomain_info.list_createUser = list_results.map((row) => ({
                            ...row,
                            isIdCheckOK: true,
                            isJoinSuccess: false,
                            userSeq: -1
                        }));
                    }
                });
            } else {
                console.log("DUPLICATE_CHECK_USERS - 이런 경우가 있나...? list_results => ", list_results);

                return {
                    ...state
                }
            }
        } else {
            console.log("DUPLICATE_CHECK_USERS - isSuccessed => ", isSuccessed);

            return {
                ...state,
                alertKind        : ConstData.ALERT_KIND.DANGER,
                alertMessage     : i18n.t("사용자_ID_중복_확인_요청_실패", { ns: "admin" }) + " (Code.972)"
            }
        }
    },

    [CREATE_USERS_SUCCESS]: (state, action) => {
        const { subDomainSeq, list_createUser, requestDate } = action.parms;
        const { isSuccessed } = action.payload;
        console.log("CREATE_USERS - ", action.payload, action.parms);

        if (isSuccessed) {
            const { list_results } = action.payload;

            if (list_results) {
                return produce (state, draft => {
                    const subDomain_info = draft.list_configSubDomain.find(info => info.subDomainSeq === subDomainSeq);
                    if (subDomain_info) {
                        subDomain_info.list_createUser = list_results;

                        let filteredList_user = subDomain_info.list_createUser.filter(info => info.isJoinSuccess);
                        if (filteredList_user && filteredList_user.length > 0) {
                            subDomain_info.list_member = subDomain_info.list_member.concat(
                                                            filteredList_user.map(row => ({
                                                                userSeq         : row.userSeq,
                                                                userID          : row.userID,
                                                                userNickname    : row.userNickname,
                                                                userProfile     : row.userProfile,
                                                                profileImgUrl   : "1",
                                                                userStatus      : ConstData.USER_STATUS.LOG_OUT,
                                                                webUserStatus   : ConstData.USER_STATUS.LOG_OUT,
                                                                userLoginDT     : requestDate,
                                                                userSignUpDT    : requestDate,
                                                                isConfigAdmin   : false,
                                                                isCreateAdmin   : false,
                                                         })));
                        }
                    }
                });
            } else {
                console.log("CREATE_USERS - 이런 경우가 있나...? list_results => ", list_results);

                return {
                    ...state
                }
            }
        } else {
            console.log("CREATE_USERS - isSuccessed => ", isSuccessed);

            return {
                ...state,
                alertKind        : ConstData.ALERT_KIND.DANGER,
                alertMessage     : i18n.t("사용자_ID_생성_요청_실패", { ns: "admin" }) + " (Code.990)"
            }
        }
    },

    [CHANGE_ALERT_MESSAGE]: (state, action) => {
        const { kind, message } = action;
        //console.log("CHANGE_ALERT_MESSAGE - ", kind, message);

        if (kind === "subDomain-check") {
            return {
                ...state,
                isCheckSubDomainOK      : false,
                alertKind               : message === "" ? ConstData.ALERT_KIND.NONE : ConstData.ALERT_KIND.DANGER,
                alertMessage            : message
            }
        } else if (kind === "subDomain-add") {
            return {
                ...state,
                isAddSubDomainOK        : false,
                alertKind               : message === "" ? ConstData.ALERT_KIND.NONE : ConstData.ALERT_KIND.DANGER,
                alertMessage            : message
            }
        } else {
            console.log(`CHANGE_ALERT_MESSAGE - kind[${kind}], message[${message}]`);

            return {
                ...state
            }
        }
    },

    [SET_ALERT_MESSAGE]: (state, action) => {
        //console.log("SET_ALERT_MESSAGE - ", action.message);

        if (action.message !== "") {
            return {
                ...state,
                alertMessage        : action.message,
                alertKind           : ConstData.ALERT_KIND.DANGER
            }
        } else {
            return {
                ...state,
                alertMessage        : "",
                alertKind           : ConstData.ALERT_KIND.NONE
            }
        }
    },

    [SET_ALERT_KIND_MESSAGE]: (state, action) => {
        //console.log("SET_ALERT_KIND_MESSAGE - ", action.message);

        if (action.message !== "") {
            return {
                ...state,
                alertMessage        : action.message,
                alertKind           : ConstData.ALERT_KIND.DANGER
            }
        } else {
            return {
                ...state,
                alertMessage        : "",
                alertKind           : ConstData.ALERT_KIND.NONE
            }
        }
    },

    /**********************************************************/
    /////////////////////// LOCAL SERVER ///////////////////////
    /**********************************************************/

    [GET_SUB_DOMAIN_LOCAL_SERVER_INFO_SUCCESS]: (state, action) => {
        //const { subDomainSeq } = action.parms; 
        const { isSuccessed } = action.payload;
        console.log("GET_SUB_DOMAIN_LOCAL_SERVER_INFO - ", action.payload, action.parms);

        if (isSuccessed) {
            const { list_localServer, list_localSite } = action.payload;

            let clist_configLocalServer = [];
            let clist_localSite = [];

            if (list_localServer && list_localServer.length > 0) {
                clist_configLocalServer = list_localServer.map(row => ({
                    localSiteSeq        : row.LOCAL_SITE_SEQ,
                    localSiteName       : row.LOCAL_SITE_NAME,
                    localServerSeq      : row.LOCAL_SERVER_SEQ,
                    localServerName     : row.LOCAL_SERVER_NM,
                    ipAddress           : row.IP_ADDRESS,
                    serverStatus        : row.LOGIN_YN,
                    isPortOpened        : row.PORT_OPEN_YN === "Y" ? true : false,
                    authCode            : row.AUTH_CD,
                    portNumber          : row.PORT_NUM,
                    historySeq          : row.LATEST_HS_SEQ,
                    historyMemo         : row.HISTORY_MEMO,
                    /** 260804 상세설정(로그인 허용/자동 로그인/업데이트 허용) 및 상세정보(생성일/로그인/로그아웃 일시) 매핑 추가 */
                    allowLoginYn        : row.ALLOW_LOGIN_YN,
                    autoLoginYn         : row.AUTO_LOGIN_YN,
                    isUpdateAllowed     : row.HICLASS_VERSION === null || row.HICLASS_VERSION === undefined,
                    // 20260813 클래스 모니터 허용값과 MQTT 사용 가능 상태를 관리자 목록에 매핑한다.
                    classMonitorAllowYn : row.CLASS_MONITOR_ALLOW_YN === "Y" ? "Y" : "N",
                    mqttAvailableYn     : row.MQTT_AVAILABLE_YN === "Y" ? "Y" : "N",
                    // 20260814 서버 타입과 실제 업데이트·MQTT 상태를 상세정보에 매핑한다.
                    localServerType     : row.LOCAL_SERVER_TYPE || "UNKNOWN",
                    localServerTypeName : row.LOCAL_SERVER_TYPE_NAME || "미지정",
                    // 20260828 자동 감지 기기 정보는 관리자 지정 타입과 별도로 상세 카드에 표시한다.
                    detectedServerType  : row.DETECTED_SERVER_TYPE || "UNKNOWN",
                    hardwareVendor      : row.HARDWARE_VENDOR || null,
                    hardwareModel       : row.HARDWARE_MODEL || null,
                    hardwareArch        : row.HARDWARE_ARCH || null,
                    hardwareDetectedDt  : row.HARDWARE_DETECTED_DT,
                    // 20260828 MediaSoup 실제 코덱 활성 상태를 상세정보에 매핑한다.
                    codecVp9UseYn       : row.CODEC_VP9_USE_YN,
                    codecVp8UseYn       : row.CODEC_VP8_USE_YN,
                    codecH264UseYn      : row.CODEC_H264_USE_YN,
                    installedSvnRevision: row.INSTALLED_SVN_REVISION,
                    lastUpdateStatus    : row.LAST_UPDATE_STATUS,
                    lastUpdateDt        : row.LAST_UPDATE_DT,
                    lastUpdateHistSeq   : row.LAST_UPDATE_HIST_SEQ,
                    // 20261022 클라우드 발급과 로컬의 실제 토큰 사용 성공을 별도로 표시한다.
                    reportTokenIssuedYn : row.UPDATE_REPORT_TOKEN_ISSUED_YN,
                    reportTokenIssuedDt : row.UPDATE_REPORT_TOKEN_ISSUED_DT,
                    reportTokenVerifiedDt: row.UPDATE_REPORT_TOKEN_VERIFIED_DT,
                    tokenResetRequestYn : row.UPDATE_TOKEN_RESET_REQUEST_YN,
                    tokenResetRequestDt : row.UPDATE_TOKEN_RESET_REQUEST_DT,
                    tokenResetReason    : row.UPDATE_TOKEN_RESET_REASON,
                    capabilityCheckDt   : row.CAPABILITY_CHECK_DT,
                    // 20261027 버전 수집 결과와 과거 정상 수집 시각을 구분해 표시한다.
                    rabbitmqInfoEnabled : row.RABBITMQ_INFO_ENABLED === "Y",
                    rabbitmqInfoQueryStatus: row.RABBITMQ_INFO_QUERY_STATUS,
                    rabbitmqVersion     : row.RABBITMQ_VERSION,
                    rabbitmqDetectedDt  : row.RABBITMQ_DETECTED_DT,
                    rabbitmqLastCheckStatus: row.RABBITMQ_LAST_CHECK_STATUS || "UNKNOWN",
                    rabbitmqLastCheckDt : row.RABBITMQ_LAST_CHECK_DT,
                    createDt            : row.CREATE_DT,
                    serverLoginDt       : row.SERVER_LOGIN_DT,
                    serverLogoutDt      : row.SERVER_LOGOUT_DT,
                    commandInfo         : [],
                    /** 로컬 서버 포트 관련 정보 기본값 추가 ... by hjkim 20251223 */
                    remoteForwardResult : {
                        success         : null,
                        localServerSeq  : -1,
                        localPort       : -1,
                        message         : null,
                        timestamp       : null,
                        alertKind       : ConstData.ALERT_KIND.NONE,
                        alertMessage    : null
                    }
                }));

                if (list_localSite && list_localSite.length > 0) {
                    clist_localSite = list_localSite.map(row => ({
                        localSiteSeq    : row.LOCAL_SITE_SEQ,
                        localSiteName   : row.LOCAL_SITE_NAME
                    }));
                }
            }

            return {
                ...state,
                list_configLocalServer  : clist_configLocalServer,
                list_localSite          : clist_localSite
            }
        } else {
            console.log("GET_SUB_DOMAIN_LOCAL_SERVER_INFO - ", action.payload);

            return {
                ...state,
                list_configLocalServer : []
            }
        }
    },

    [GET_USER_LOCAL_SERVER_INFO_SUCCESS]: (state, action) => {
        //const { subDomainSeq, selectedUserSeq } = action.parms;
        const { isSuccessed } = action.payload;
        console.log("GET_USER_LOCAL_SERVER_INFO - ", action.payload, action.parms);

        if (isSuccessed) {
            const { list_localServer } = action.payload;

            let clist_configLocalServer = [];

            if (list_localServer && list_localServer.length > 0) {
                clist_configLocalServer = list_localServer.map(row => ({
                    localSiteSeq        : row.LOCAL_SITE_SEQ,
                    localSiteName       : row.LOCAL_SITE_NAME,
                    localServerSeq      : row.LOCAL_SERVER_SEQ,
                    localServerName     : row.LOCAL_SERVER_NM,
                    ipAddress           : row.IP_ADDRESS,
                    authCode            : row.AUTH_CD,
                    serverStatus        : row.LOGIN_YN,
                    isPortOpened        : row.PORT_OPEN_YN === "Y" ? true : false,
                    portNumber          : row.PORT_NUM,
                    historySeq          : row.LATEST_HS_SEQ,
                    historyMemo         : row.HISTORY_MEMO,
                    /** 260804 상세설정(로그인 허용/자동 로그인/업데이트 허용) 및 상세정보(생성일/로그인/로그아웃 일시) 매핑 추가 */
                    allowLoginYn        : row.ALLOW_LOGIN_YN,
                    autoLoginYn         : row.AUTO_LOGIN_YN,
                    isUpdateAllowed     : row.HICLASS_VERSION === null || row.HICLASS_VERSION === undefined,
                    // 20260813 클래스 모니터 허용값과 MQTT 사용 가능 상태를 관리자 목록에 매핑한다.
                    classMonitorAllowYn : row.CLASS_MONITOR_ALLOW_YN === "Y" ? "Y" : "N",
                    mqttAvailableYn     : row.MQTT_AVAILABLE_YN === "Y" ? "Y" : "N",
                    // 20260814 사용자 기준 조회에서도 관리자 상세정보와 같은 상태를 유지한다.
                    localServerType     : row.LOCAL_SERVER_TYPE || "UNKNOWN",
                    localServerTypeName : row.LOCAL_SERVER_TYPE_NAME || "미지정",
                    // 20260828 MediaSoup 실제 코덱 활성 상태를 상세정보에 매핑한다.
                    codecVp9UseYn       : row.CODEC_VP9_USE_YN,
                    codecVp8UseYn       : row.CODEC_VP8_USE_YN,
                    codecH264UseYn      : row.CODEC_H264_USE_YN,
                    installedSvnRevision: row.INSTALLED_SVN_REVISION,
                    lastUpdateStatus    : row.LAST_UPDATE_STATUS,
                    lastUpdateDt        : row.LAST_UPDATE_DT,
                    lastUpdateHistSeq   : row.LAST_UPDATE_HIST_SEQ,
                    // 20261022 사용자 기준 목록에서도 같은 토큰 상태를 유지한다.
                    reportTokenIssuedYn : row.UPDATE_REPORT_TOKEN_ISSUED_YN,
                    reportTokenIssuedDt : row.UPDATE_REPORT_TOKEN_ISSUED_DT,
                    reportTokenVerifiedDt: row.UPDATE_REPORT_TOKEN_VERIFIED_DT,
                    tokenResetRequestYn : row.UPDATE_TOKEN_RESET_REQUEST_YN,
                    tokenResetRequestDt : row.UPDATE_TOKEN_RESET_REQUEST_DT,
                    tokenResetReason    : row.UPDATE_TOKEN_RESET_REASON,
                    capabilityCheckDt   : row.CAPABILITY_CHECK_DT,
                    // 20261027 사용자 기준 목록도 동일한 RabbitMQ 상세 항목을 전달한다.
                    rabbitmqInfoEnabled : row.RABBITMQ_INFO_ENABLED === "Y",
                    rabbitmqInfoQueryStatus: row.RABBITMQ_INFO_QUERY_STATUS,
                    rabbitmqVersion     : row.RABBITMQ_VERSION,
                    rabbitmqDetectedDt  : row.RABBITMQ_DETECTED_DT,
                    rabbitmqLastCheckStatus: row.RABBITMQ_LAST_CHECK_STATUS || "UNKNOWN",
                    rabbitmqLastCheckDt : row.RABBITMQ_LAST_CHECK_DT,
                    createDt            : row.CREATE_DT,
                    serverLoginDt       : row.SERVER_LOGIN_DT,
                    serverLogoutDt      : row.SERVER_LOGOUT_DT,
                    commandInfo         : [],
                    /** 로컬 서버 포트 관련 정보 기본값 추가 ... by hjkim 20251223 */
                    remoteForwardResult : {
                        success         : null,
                        localServerSeq  : -1,
                        localPort       : -1,
                        message         : null,
                        timestamp       : null,
                        alertKind       : ConstData.ALERT_KIND.NONE,
                        alertMessage    : null
                    }
                }));
            }

            return {
                ...state,
                list_configLocalServer  : clist_configLocalServer
            }
        } else {
            console.log("GET_USER_LOCAL_SERVER_INFO - ", action.payload);

            return {
                ...state,
                list_configLocalServer : []
            }
        }
    },

    [CREATE_LOCAL_SERVER_SUCCESS]: (state, action) => {
        const { serverName, localServerType } = action.parms;
        const { isSuccessed } = action.payload;
        //console.log("CREATE_LOCAL_SERVER - ", action.payload, action.parms);

        if (isSuccessed) {
            const { isCreateSuccess } = action.payload;

            if (isCreateSuccess) {
                const { serverSEQ, authCode } = action.payload;
                const { localSiteSeq, localSiteName } = action.parms;

                const newServer_info = {
                    localSiteSeq,
                    localSiteName,
                    localServerSeq      : serverSEQ,
                    localServerName     : serverName,
                    ipAddress           : null,
                    authCode,
                    serverStatus        : "N",
                    isPortOpened        : false,
                    portNumber          : -1,
                    historySeq          : -1,
                    historyMemo         : null,
                    // 20260814 신규 서버의 타입은 생성 요청값과 기준정보 표시명을 즉시 반영한다.
                    localServerType     : localServerType || "UNKNOWN",
                    localServerTypeName : (state.list_localServerType.find(info => info.localServerType === (localServerType || "UNKNOWN")) || {}).localServerTypeName || "미지정",
                    installedSvnRevision: null,
                    lastUpdateStatus    : null,
                    lastUpdateDt        : null,
                    lastUpdateHistSeq   : null,
                    mqttAvailableYn     : "N",
                    capabilityCheckDt   : null,
                    /** 로컬 서버 포트 관련 정보 기본값 추가 ... by hjkim 20251223 */
                    remoteForwardResult : {
                        success         : null,
                        localServerSeq  : -1,
                        localPort       : -1,
                        message         : null,
                        timestamp       : null,
                        alertKind       : ConstData.ALERT_KIND.NONE,
                        alertMessage    : null
                    }
                };

                return {
                    ...state,
                    list_configLocalServer  : state.list_configLocalServer.concat(newServer_info),
                    // 260804 방금 추가한 서버로 자동 페이지 이동시키기 위해 seq 기록
                    lastCreatedLocalServerSeq : serverSEQ,
                    alertKind               : ConstData.ALERT_KIND.SUCCESS,
                    alertMessage            : i18n.t("로컬_서버_등록_성공", { ns: "admin" }),
                    localServerAlertEventId : (state.localServerAlertEventId || 0) + 1,
                    localServerAlertTarget  : "CREATE"
                }
            } else {
                console.log("CREATE_LOCAL_SERVER_SUCCESS - isCreateSuccess => ", isCreateSuccess);

                return {
                    ...state,
                    alertKind               : ConstData.ALERT_KIND.DANGER,
                    alertMessage            : i18n.t("로컬_서버_등록_실패", { ns: "admin" }) + " (Code.AL202)",
                    localServerAlertEventId : (state.localServerAlertEventId || 0) + 1,
                    localServerAlertTarget  : "CREATE"
                }
            }
        } else {
            console.log("CREATE_LOCAL_SERVER_SUCCESS - ", action.payload);

            return {
                ...state,
                alertKind               : ConstData.ALERT_KIND.DANGER,
                alertMessage            : i18n.t("로컬_서버_등록_요청_실패", { ns: "admin" }) + " (Code.AL201)",
                localServerAlertEventId : (state.localServerAlertEventId || 0) + 1,
                localServerAlertTarget  : "CREATE"
            }
        }
    },

    [REMOVE_LOCAL_SERVER_SUCCESS]: (state, action) => {
        const { localServerSeq } = action.parms;
        const { isSuccessed } = action.payload;
        //console.log("REMOVE_LOCAL_SERVER_SUCCESS - ", action.payload, action.parms);

        if (isSuccessed) {
            const { isDeleteSuccess } = action.payload;

            if (isDeleteSuccess) {
                return {
                    ...state,
                    list_configLocalServer  : state.list_configLocalServer.filter(info => info.localServerSeq !== localServerSeq),
                    alertKind               : ConstData.ALERT_KIND.SUCCESS,
                    alertMessage            : i18n.t("로컬_서버_삭제_성공", { ns: "admin" }),
                    localServerAlertEventId : (state.localServerAlertEventId || 0) + 1,
                    localServerAlertTarget  : "PAGE"
                }
            } else {
                console.log("REMOVE_LOCAL_SERVER_SUCCESS - isDeleteSuccess => ", isDeleteSuccess);

                return {
                    ...state,
                    alertKind               : ConstData.ALERT_KIND.DANGER,
                    alertMessage            : i18n.t("로컬_서버_삭제_실패", { ns: "admin" }) + " (Code.AL204)",
                    localServerAlertEventId : (state.localServerAlertEventId || 0) + 1,
                    localServerAlertTarget  : "PAGE"
                }
            }
        } else {
            console.log("REMOVE_LOCAL_SERVER_SUCCESS - ", action.payload);

            return {
                ...state,
                alertKind               : ConstData.ALERT_KIND.DANGER,
                alertMessage            : i18n.t("로컬_서버_삭제_요청_실패", { ns: "admin" }) + " (Code.AL203)",
                localServerAlertEventId : (state.localServerAlertEventId || 0) + 1,
                localServerAlertTarget  : "PAGE"
            }
        }
    },

    [CHANGE_LOCAL_SITE_INFO_SUCCESS]: (state, action) => {
        //console.log("CHANGE_LOCAL_SITE_INFO_SUCCESS - ", action.payload, action.parms);
        const { localServerSeq, localSiteSeq, localSiteName } = action.parms;

        const { isSuccessed } = action.payload;
        if (isSuccessed) {
            const { isUpdateSuccess } = action.payload;

            if (isUpdateSuccess) {
                return produce (state, draft => {
                    const localServer_info = draft.list_configLocalServer.find(info => info.localServerSeq === localServerSeq);
                    if (localServer_info) {
                        localServer_info.localSiteSeq = localSiteSeq;
                        localServer_info.localSiteName = localSiteName;
                    }
                });
            } else {
                console.log("CHANGE_LOCAL_SITE_INFO_SUCCESS - isUpdateSuccess => ", isUpdateSuccess);

                return {
                    ...state
                }
            }
        } else {
            console.log("CHANGE_LOCAL_SITE_INFO_SUCCESS - ", action.payload);

            return {
                ...state
            }
        }
    },

    // 20260828 로컬 서버 이름 인라인 수정 결과 반영 (확인 클릭 시 즉시 저장)
    // - 상세설정 저장(configAlert)과 동일하게 해당 서버 행에서만 결과를 표시한다 (페이지 상단 알림 아님)
    [CHANGE_LOCAL_SERVER_NAME_SUCCESS]: (state, action) => {
        const { localServerSeq, localServerName } = action.parms;
        const { isSuccessed } = action.payload;

        return produce(state, draft => {
            const localServer_info = draft.list_configLocalServer.find(info => info.localServerSeq === localServerSeq);
            if (!localServer_info) return;

            const isUpdateSuccess = isSuccessed && action.payload.isUpdateSuccess;

            if (isUpdateSuccess) {
                localServer_info.localServerName = localServerName;
                localServer_info.nameAlertKind = ConstData.ALERT_KIND.SUCCESS;
                localServer_info.nameAlertMessage = i18n.t("로컬_서버_이름_수정_성공", { ns: "admin" });
            } else if (isSuccessed) {
                console.log("CHANGE_LOCAL_SERVER_NAME_SUCCESS - isUpdateSuccess => ", isUpdateSuccess);
                localServer_info.nameAlertKind = ConstData.ALERT_KIND.DANGER;
                localServer_info.nameAlertMessage = i18n.t("로컬_서버_이름_수정_실패", { ns: "admin" });
            } else {
                console.log("CHANGE_LOCAL_SERVER_NAME_SUCCESS - ", action.payload);
                localServer_info.nameAlertKind = ConstData.ALERT_KIND.DANGER;
                localServer_info.nameAlertMessage = i18n.t("로컬_서버_이름_수정_요청_실패", { ns: "admin" });
            }
            localServer_info.nameAlertEventId = (localServer_info.nameAlertEventId || 0) + 1;
        });
    },

    [CHANGE_LOCAL_SERVER_PORT_INFO_SUCCESS]: (state, action) => {
        const { localServerSeq, status } = action.parms;
        const { isSuccessed } = action.payload;
        //console.log("CHANGE_LOCAL_SERVER_PORT_INFO - ", action.payload, action.parms);

        if (isSuccessed) {
            const { isUpdateSuccess } = action.payload;

            if (isUpdateSuccess) {
                return produce (state, draft => {
                    const localServer_info = draft.list_configLocalServer.find(info => info.localServerSeq === localServerSeq);
                    if (localServer_info) {
                        localServer_info.isPortOpened = status;

                        if (status) {
                            const { portNumber, historyMemo } = action.parms;
                            const { historySEQ } = action.payload;

                            localServer_info.portNumber = portNumber;
                            localServer_info.historySeq = historySEQ;
                            localServer_info.historyMemo = historyMemo;

                            localServer_info.remoteForwardResult = {
                                success         : null,
                                localServerSeq  : localServer_info.localServerSeq,
                                localPort       : portNumber,
                                message         : null,
                                timestamp       : null,
                                alertKind       : ConstData.ALERT_KIND.NONE,
                                alertMessage    : null
                            };
                        } else {
                            localServer_info.portNumber = -1;
                            localServer_info.historySeq = -1;
                            localServer_info.historyMemo = null;

                            /** 로컬 서버 포트 관련 정보 기본값 추가 ... by hjkim 20251223 */
                            localServer_info.remoteForwardResult = {
                                success         : null,
                                localServerSeq  : -1,
                                localPort       : -1,
                                message         : null,
                                timestamp       : null,
                                alertKind       : ConstData.ALERT_KIND.NONE,
                                alertMessage    : null
                            };
                        }
                    }
                });
            } else {
                console.log("CHANGE_LOCAL_SERVER_PORT_INFO - isUpdateSuccess => ", isUpdateSuccess);

                return {
                    ...state
                }
            }
        } else {
            console.log("CHANGE_LOCAL_SERVER_PORT_INFO - ", action.payload);

            return {
                ...state
            }
        }
    },

    // 260804 로컬서버 상세설정(로그인 허용/자동 로그인/업데이트 허용) 저장 결과 반영
    [CHANGE_LOCAL_SERVER_CONFIG_INFO_SUCCESS]: (state, action) => {
        const { localServerSeq, allowLoginYn, autoLoginYn, updateAllowYn, classMonitorAllowYn, localServerType, localServerTypeName } = action.parms;
        const { isSuccessed } = action.payload;
        //console.log("CHANGE_LOCAL_SERVER_CONFIG_INFO_SUCCESS - ", action.payload, action.parms);

        if (isSuccessed) {
            const { isUpdateSuccess } = action.payload;

            if (isUpdateSuccess) {
                // 260804 상세설정 저장 성공 알림 추가
                return produce (state, draft => {
                    const localServer_info = draft.list_configLocalServer.find(info => info.localServerSeq === localServerSeq);
                    if (localServer_info) {
                        localServer_info.allowLoginYn = allowLoginYn;
                        localServer_info.autoLoginYn = allowLoginYn === "Y" ? autoLoginYn : "N";
                        localServer_info.isUpdateAllowed = updateAllowYn === "Y";
                        // 20260821 MQTT 포트가 확인된 서버는 업데이트 허용과 별개로 클래스 모니터 허용값을 반영한다.
                        localServer_info.classMonitorAllowYn = (updateAllowYn === "Y" || localServer_info.mqttAvailableYn === "Y") && classMonitorAllowYn === "Y" ? "Y" : "N";
                        // 20260814 같은 체크 저장 결과에 서버 타입도 즉시 반영한다.
                        localServer_info.localServerType = localServerType || localServer_info.localServerType;
                        localServer_info.localServerTypeName = localServerTypeName || localServer_info.localServerTypeName;
                        // 20260813 같은 문구의 반복 저장도 해당 서버 행에서 다시 표시한다.
                        localServer_info.configAlertKind = ConstData.ALERT_KIND.SUCCESS;
                        localServer_info.configAlertMessage = i18n.t("로컬_서버_상세설정_저장_성공", { ns: "admin" });
                        localServer_info.configAlertEventId = (localServer_info.configAlertEventId || 0) + 1;
                    }
                    // 20260813 상세설정 성공 알림은 상단이 아닌 해당 서버 행에서만 표시한다.
                    draft.alertKind = ConstData.ALERT_KIND.NONE;
                    draft.alertMessage = "";
                });
            } else {
                console.log("CHANGE_LOCAL_SERVER_CONFIG_INFO_SUCCESS - isUpdateSuccess => ", isUpdateSuccess);
                // 20260814 상세설정 실패도 해당 서버 행에서 반복 표시한다.
                return produce(state, draft => {
                    const localServer_info = draft.list_configLocalServer.find(info => info.localServerSeq === localServerSeq);
                    if (localServer_info) {
                        localServer_info.configAlertKind = ConstData.ALERT_KIND.DANGER;
                        localServer_info.configAlertMessage = i18n.t("로컬_서버_상세설정_저장_실패", { ns: "admin" });
                        localServer_info.configAlertEventId = (localServer_info.configAlertEventId || 0) + 1;
                    }
                    draft.alertKind = ConstData.ALERT_KIND.NONE;
                    draft.alertMessage = "";
                });
            }
        } else {
            console.log("CHANGE_LOCAL_SERVER_CONFIG_INFO_SUCCESS - ", action.payload);
            // 20260814 상세설정 요청 실패도 공용 알림과 섞지 않고 해당 행에 표시한다.
            return produce(state, draft => {
                const localServer_info = draft.list_configLocalServer.find(info => info.localServerSeq === localServerSeq);
                if (localServer_info) {
                    localServer_info.configAlertKind = ConstData.ALERT_KIND.DANGER;
                    localServer_info.configAlertMessage = i18n.t("로컬_서버_상세설정_저장_요청_실패", { ns: "admin" });
                    localServer_info.configAlertEventId = (localServer_info.configAlertEventId || 0) + 1;
                }
                draft.alertKind = ConstData.ALERT_KIND.NONE;
                draft.alertMessage = "";
            });
        }
    },

    // 20260814 서버 타입 목록을 화면용 camelCase 구조로 변환한다.
    // 20260828 명령 capability 및 마지막 ACK 상태를 해당 서버 카드에 반영한다.
    [GET_LOCAL_SERVER_COMMAND_INFO_SUCCESS]: (state, action) => {
        if (!action.payload || !action.payload.isSuccessed) return state;
        const list = action.payload.list_commandInfo || [];
        return produce(state, draft => {
            const info = draft.list_configLocalServer.find(item => item.localServerSeq === action.parms.localServerSeq);
            if (info) {
                // 20260828 직접 수신한 최신 ACK가 DB 재조회 결과의 이전 R 상태로 되돌아가지 않도록 보호한다.
                const previous = info.commandInfo || [];
                const refreshed = list.map(item => {
                    const old = previous.find(prev => prev.COMMAND_NAME === item.COMMAND_NAME && prev.LAST_REQUEST_ID === item.LAST_REQUEST_ID);
                    const oldCapability = previous.find(prev => prev.COMMAND_NAME === item.COMMAND_NAME && prev.SUPPORTED_YN === "Y");
                    const oldStatus = old && old.LAST_ACK_STATUS;
                    const newStatus = item.LAST_ACK_STATUS;
                    const isNewerThanRequest = ["A", "C", "F", "T"].includes(oldStatus) && newStatus === "R";
                    if (isNewerThanRequest) return { ...item, ...old };
                    // 20260828 개별 명령 요청 저장 시 capability 지원 여부(Y)가 N으로 초기화되지 않도록 유지한다.
                    return oldCapability ? { ...item, SUPPORTED_YN: "Y", CAPABILITY_DT: oldCapability.CAPABILITY_DT } : item;
                });
                // 20260828 capability ACK가 만든 지원 명령 행이 DB 조회 결과에 없어도 유지한다.
                previous.forEach(item => {
                    if (!refreshed.some(current => current.COMMAND_NAME === item.COMMAND_NAME) && ["A", "C", "F", "T"].includes(item.LAST_ACK_STATUS)) {
                        refreshed.push(item);
                    }
                });
                info.commandInfo = refreshed;
            }
        });
    },

    [SEND_LOCAL_SERVER_COMMAND_SUCCESS]: (state, action) => {
        const serverSeq = action.parms.localServerSeq;
        return produce(state, draft => {
            const info = draft.list_configLocalServer.find(item => item.localServerSeq === serverSeq);
            if (info) {
                info.commandRequestId = action.payload && action.payload.requestId;
                info.commandAlertKind = action.payload && action.payload.isSuccessed ? ConstData.ALERT_KIND.SUCCESS : ConstData.ALERT_KIND.DANGER;
                info.commandAlertMessage = action.payload && action.payload.isSuccessed ? i18n.t("명령_전송_성공", { ns: "admin" }) : (action.payload.errMsg || i18n.t("명령_전송_실패", { ns: "admin" }));
                info.commandAlertEventId = (info.commandAlertEventId || 0) + 1;
            }
        });
    },

    [MQ_RCV_LOCAL_SERVER_COMMAND_ACK]: (state, action) => {
        const ack = action.payload || {};
        const serverSeq = Number(ack.serverSeq);
        if (!serverSeq) return state;
        return produce(state, draft => {
            const info = draft.list_configLocalServer.find(item => Number(item.localServerSeq) === serverSeq);
            if (!info) return;

            const current = info.commandInfo || [];
            if (ack.ackType !== "capability" && ack.commandName) {
                // 20260901 일반 명령 ACK는 해당 명령 행만 갱신하고 다른 지원 상태는 보존한다.
                const old = current.find(item => item.COMMAND_NAME === ack.commandName) || {};
                const next = {
                    ...old,
                    COMMAND_NAME: ack.commandName,
                    LAST_REQUEST_ID: ack.requestId || old.LAST_REQUEST_ID || null,
                    LAST_ACK_STATUS: ack.status || old.LAST_ACK_STATUS || "R",
                    LAST_ACK_MESSAGE: ack.message || null
                };
                info.commandInfo = current.some(item => item.COMMAND_NAME === ack.commandName)
                    ? current.map(item => item.COMMAND_NAME === ack.commandName ? next : item)
                    : [...current, next];
                info.commandAlertKind = ConstData.ALERT_KIND.SUCCESS;
                info.commandAlertMessage = i18n.t("명령_전송_성공", { ns: "admin" });
                info.commandAlertEventId = (info.commandAlertEventId || 0) + 1;
                // 20260917 코덱 적용 완료 ACK의 실제 요청값을 재조회 전에도 카드 배지에 반영한다.
                if (ack.commandName === "codecConfigApply" && ack.status === "C" && Array.isArray(ack.codecs)) {
                    const codecUseByName = new Map(ack.codecs.map(codec => [String(codec.codecName || "").toUpperCase(), codec.useYn === "N" ? "N" : "Y"]));
                    if (codecUseByName.has("VP9")) info.codecVp9UseYn = codecUseByName.get("VP9");
                    if (codecUseByName.has("VP8")) info.codecVp8UseYn = codecUseByName.get("VP8");
                    if (codecUseByName.has("H264")) info.codecH264UseYn = codecUseByName.get("H264");
                }
                return;
            }
            const supported = Array.isArray(ack.supportedCommands) ? ack.supportedCommands : [];
            // 20260828 capability ACK에 새 명령이 추가되어도 기존 명령 상태와 함께 보존한다.
            const commandNames = Array.from(new Set([
                "commandCapabilityRequest",
                ...current.map(item => item.COMMAND_NAME),
                ...supported
            ].filter(Boolean)));
            info.commandInfo = commandNames.map(commandName => {
                const old = current.find(item => item.COMMAND_NAME === commandName) || {};
                return {
                    ...old,
                    COMMAND_NAME: commandName,
                    LAST_REQUEST_ID: ack.requestId || old.LAST_REQUEST_ID || null,
                    SUPPORTED_YN: supported.includes(commandName) ? "Y" : "N",
                    CAPABILITY_DT: formatCapabilityDateTime(ack.checkedAt) || old.CAPABILITY_DT || null,
                    LAST_ACK_STATUS: ack.status || old.LAST_ACK_STATUS || "C",
                    LAST_ACK_MESSAGE: ack.message || old.LAST_ACK_MESSAGE || null
                };
            });
            info.capabilityCheckDt = formatCapabilityDateTime(ack.checkedAt) || info.capabilityCheckDt;
            info.commandAlertKind = ConstData.ALERT_KIND.SUCCESS;
            info.commandAlertMessage = i18n.t("명령_기능_확인_완료", { ns: "admin" });
            info.commandAlertEventId = (info.commandAlertEventId || 0) + 1;
        });
    },

    [GET_LOCAL_SERVER_TYPES_SUCCESS]: (state, action) => {
        if (!action.payload.isSuccessed) return state;
        const list = action.payload.listLocalServerType || [];
        return {
            ...state,
            list_localServerType: list.map(row => ({
                localServerType: row.LOCAL_SERVER_TYPE,
                localServerTypeName: row.LOCAL_SERVER_TYPE_NAME,
                useYn: row.USE_YN === "Y" ? "Y" : "N",
                displayOrder: row.DISPLAY_ORDER
            }))
        };
    },

    // 20260814 타입 사용 여부 저장 성공 시 기준정보 목록만 갱신한다.
    [UPDATE_LOCAL_SERVER_TYPE_USE_SUCCESS]: (state, action) => {
        if (!action.payload.isSuccessed || !action.payload.isUpdateSuccess) return state;
        return produce(state, draft => {
            const info = draft.list_localServerType.find(item => item.localServerType === action.parms.localServerType);
            if (info) info.useYn = action.parms.useYn;
            draft.alertKind = ConstData.ALERT_KIND.SUCCESS;
            draft.alertMessage = i18n.t("로컬_서버_타입_저장_성공", { ns: "admin" });
            draft.localServerAlertEventId = (draft.localServerAlertEventId || 0) + 1;
            draft.localServerAlertTarget = "TYPE";
        });
    },

    // 20260814 일괄 저장 성공 응답의 전체 타입 목록으로 공통 상태를 한 번에 교체한다.
    [UPDATE_LOCAL_SERVER_TYPES_USE_SUCCESS]: (state, action) => {
        if (!action.payload.isSuccessed || !action.payload.isUpdateSuccess) return state;
        const list = action.payload.listLocalServerType || [];
        return {
            ...state,
            list_localServerType: list.map(row => ({
                localServerType: row.LOCAL_SERVER_TYPE,
                localServerTypeName: row.LOCAL_SERVER_TYPE_NAME,
                useYn: row.USE_YN === "Y" ? "Y" : "N",
                displayOrder: row.DISPLAY_ORDER
            })),
            alertKind: ConstData.ALERT_KIND.SUCCESS,
            alertMessage: i18n.t("로컬_서버_타입_저장_성공", { ns: "admin" }),
            localServerAlertEventId: (state.localServerAlertEventId || 0) + 1,
            localServerAlertTarget: "TYPE"
        };
    },

    [CLASS_OPEN_ON_LOCAL_SITE_SUCCESS]: (state, action) => {
        //console.log("CLASS_OPEN_ON_LOCAL_SITE_SUCCESS - ", action.payload);

        const { isSuccessed } = action.payload;
        const { localSiteSeq, openLocalSiteSeq } = action.parms;

        if (isSuccessed) {
            const { isAddSuccess } = action.payload;
            if (isAddSuccess) {
                return produce (state, draft => {
                    const localSite_info = draft.list_configLocalSite.find(info => info.localSiteSeq === localSiteSeq);
                    if (localSite_info) {
                        let openSite_info = localSite_info.list_openableLocalSite.find(info => info.localSiteSeq === openLocalSiteSeq);
                        if (openSite_info) {
                            localSite_info.list_openLocalSite.push(openSite_info);
                            localSite_info.list_openableLocalSite = localSite_info.list_openableLocalSite.filter(info => info.localSiteSeq !== openLocalSiteSeq);
                        }
                    }
                });
            } else {
                console.log("CLASS_OPEN_ON_LOCAL_SITE_SUCCESS - isAddSuccess => ", isAddSuccess);
                return {
                    ...state
                }
            }
        } else {
            console.log("CLASS_OPEN_ON_LOCAL_SITE_SUCCESS - isSuccessed => ", isSuccessed);
            return {
                ...state
            }
        }
    },

    [CLASS_CLOSE_ON_LOCAL_SITE_SUCCESS]: (state, action) => {
        // console.log("CLASS_CLOSE_ON_LOCAL_SITE_SUCCESS - ", action.payload);

        const { isSuccessed } = action.payload;
        const { localSiteSeq, openLocalSiteSeq } = action.parms;

        if (isSuccessed) {
            const { isDeleteSuccess } = action.payload;
            if (isDeleteSuccess) {
                return produce (state, draft => {
                    const localSite_info = draft.list_configLocalSite.find(info => info.localSiteSeq === localSiteSeq);
                    if (localSite_info) {
                        let openSite_info = localSite_info.list_openLocalSite.find(info => info.localSiteSeq === openLocalSiteSeq);
                        if (openSite_info) {
                            localSite_info.list_openableLocalSite.push(openSite_info);
                            localSite_info.list_openLocalSite = localSite_info.list_openLocalSite.filter(info => info.localSiteSeq !== openLocalSiteSeq);
                        }
                    }
                });
            } else {
                console.log("CLASS_CLOSE_ON_LOCAL_SITE_SUCCESS - isDeleteSuccess => ", isDeleteSuccess);
                return {
                    ...state
                }
            }
        } else {
            console.log("CLASS_CLOSE_ON_LOCAL_SITE_SUCCESS - isSuccessed => ", isSuccessed);
            return {
                ...state
            }
        }
    },

    [CLEAR_REMOTE_FORWARD_INFO]: (state, action) => {
        const { localServerSeq } = action.payload;
        // console.log("CLEAR_REMOTE_FORWARD_INFO - payload => ", action.payload);

        return produce(state, draft => {
            const localServer_info = draft.list_configLocalServer.find(info => info.localServerSeq === localServerSeq);
            if (localServer_info) {
                localServer_info.remoteForwardResult = {
                    success         : null,
                    localServerSeq  : -1,
                    localPort       : -1,
                    message         : null,
                    timestamp       : null,
                    alertKind       : ConstData.ALERT_KIND.NONE,
                    alertMessage    : null
                };
            }
        });
    },

    [GET_LOCAL_SITE_LIST_SUCCESS]: (state, action) => {
        // console.log("GET_LOCAL_SITE_LIST_SUCCESS - ", action.payload);
        const { isSuccessed } = action.payload;

        if (isSuccessed) {
            const { list_localSite } = action.payload;

            let clist_configLocalSite = [];

            if (list_localSite && list_localSite.length > 0) {
                clist_configLocalSite = list_localSite.map(row => ({
                    localSiteSeq            : row.LOCAL_SITE_SEQ,
                    localSiteName           : row.LOCAL_SITE_NAME,
                    list_openLocalSite      : row.list_openLocalSite === undefined || row.list_openLocalSite === null ?
                                                [] : row.list_openLocalSite.map(siteRow => ({
                                                    localSiteSeq    : siteRow.LOCAL_SITE_SEQ,
                                                    localSiteName   : siteRow.LOCAL_SITE_NAME
                                                })),
                    list_openableLocalSite  : row.list_openableLocalSite === undefined || row.list_openableLocalSite === null ?
                                                [] : row.list_openableLocalSite.map(siteRow => ({
                                                    localSiteSeq    : siteRow.LOCAL_SITE_SEQ,
                                                    localSiteName   : siteRow.LOCAL_SITE_NAME
                                                }))
                }));
            }

            return {
                ...state,
                list_configLocalSite    : clist_configLocalSite,
                alertMessage            : "",
                alertKind               : ConstData.ALERT_KIND.NONE
            }
        } else {
            console.log("GET_LOCAL_SITE_LIST_SUCCESS - ", action.payload);

            return {
                ...state,
                list_configLocalSite    : [],
                alertKind               : ConstData.ALERT_KIND.DANGER,
                alertMessage            : i18n.t("로컬_사이트_목록_불러오기_요청_실패", { ns: "admin" }) + " (Code.AL201)"
            }

        }
    },

    [CREATE_LOCAL_SITE_SUCCESS]: (state, action) => {
        //console.log("CREATE_LOCAL_SITE_SUCCESS - ", action.payload, action.parms);
        const { isSuccessed } = action.payload;

        if (isSuccessed) {
            const { isCreateSuccess } = action.payload;

            if (isCreateSuccess) {
                const { localSiteSEQ } = action.payload;
                const { localSiteName } = action.parms;

                if (localSiteSEQ && localSiteSEQ > 0) {
                    return produce (state, draft => {
                        draft.list_configLocalSite = draft.list_configLocalSite.map(info => ({
                            ...info,
                            list_openableLocalSite: info.list_openableLocalSite.concat({
                                localSiteSeq: localSiteSEQ,
                                localSiteName
                            })
                        }));

                        let new_local_site = {
                            localSiteSeq: localSiteSEQ,
                            localSiteName,
                            list_openLocalSite: [],
                            list_openableLocalSite: state.list_configLocalSite.map(info => ({
                                localSiteSeq: info.localSiteSeq,
                                localSiteName: info.localSiteName
                            }))
                        };

                        draft.list_configLocalSite.push(new_local_site);
                    });
                }
            } else {
                console.log("CREATE_LOCAL_SITE_SUCCESS - isCreateSuccess is ", action.payload);

                return {
                    ...state,
                }
            }
        }else {
            console.log("CREATE_LOCAL_SITE_SUCCESS - isSuccessed is ", action.payload);

            return {
                ...state,
            }
        }
    },

    [DELETE_LOCAL_SITE_SUCCESS]: (state, action) => {
        //console.log("DELETE_LOCAL_SITE_SUCCESS - ", action.payload, action.parms);
        const { isSuccessed } = action.payload;

        if (isSuccessed) {
            const { isDeleteSuccess } = action.payload;

            if (isDeleteSuccess) {
                const { localSiteSeq } = action.parms;

                return produce (state, draft => {
                    draft.list_configLocalSite = draft.list_configLocalSite.filter(info => info.localSiteSeq !== localSiteSeq);
                    draft.list_configLocalSite.forEach(info => {
                        info.list_openLocalSite = info.list_openLocalSite.filter(site => site.localSiteSeq !== localSiteSeq);
                        info.list_openableLocalSite = info.list_openableLocalSite.filter(site => site.localSiteSeq !== localSiteSeq);
                    });
                })
            } else {
                console.log("DELETE_LOCAL_SITE_SUCCESS - isDeleteSuccess is ", action.payload);

                return {
                    ...state,
                }
            }
        } else {
            console.log("DELETE_LOCAL_SITE_SUCCESS - isSuccessed is ", action.payload);

            return {
                ...state,
            }
        }
    },

    // 20260828 로컬 사이트 이름 인라인 수정 결과 반영 (확인 클릭 시 즉시 저장, 결과는 페이지 상단 알림으로 표시)
    // - 다른 사이트의 list_openLocalSite/list_openableLocalSite에도 같은 사이트가 이름과 함께 중복 저장돼 있어 함께 갱신한다.
    // - 로컬 서버 관리 화면의 configAlert와 동일하게 해당 사이트 행에서만 결과를 표시한다 (페이지 상단 알림 아님)
    [CHANGE_LOCAL_SITE_NAME_SUCCESS]: (state, action) => {
        const { localSiteSeq, localSiteName } = action.parms;
        const { isSuccessed } = action.payload;

        return produce(state, draft => {
            const isUpdateSuccess = isSuccessed && action.payload.isUpdateSuccess;

            if (isUpdateSuccess) {
                draft.list_configLocalSite.forEach(info => {
                    if (info.localSiteSeq === localSiteSeq) {
                        info.localSiteName = localSiteName;
                    }
                    info.list_openLocalSite = (info.list_openLocalSite || []).map(site =>
                        site.localSiteSeq === localSiteSeq ? { ...site, localSiteName } : site
                    );
                    info.list_openableLocalSite = (info.list_openableLocalSite || []).map(site =>
                        site.localSiteSeq === localSiteSeq ? { ...site, localSiteName } : site
                    );
                });
            }

            const site_info = draft.list_configLocalSite.find(info => info.localSiteSeq === localSiteSeq);
            if (!site_info) return;

            if (isUpdateSuccess) {
                site_info.nameAlertKind = ConstData.ALERT_KIND.SUCCESS;
                site_info.nameAlertMessage = i18n.t("로컬_사이트_이름_수정_성공", { ns: "admin" });
            } else if (isSuccessed) {
                console.log("CHANGE_LOCAL_SITE_NAME_SUCCESS - isUpdateSuccess => ", isUpdateSuccess);
                site_info.nameAlertKind = ConstData.ALERT_KIND.DANGER;
                site_info.nameAlertMessage = i18n.t("로컬_사이트_이름_수정_실패", { ns: "admin" });
            } else {
                console.log("CHANGE_LOCAL_SITE_NAME_SUCCESS - ", action.payload);
                site_info.nameAlertKind = ConstData.ALERT_KIND.DANGER;
                site_info.nameAlertMessage = i18n.t("로컬_사이트_이름_수정_요청_실패", { ns: "admin" });
            }
            site_info.nameAlertEventId = (site_info.nameAlertEventId || 0) + 1;
        });
    },

    [GET_LITE_SERVER_LIST_SUCCESS]: (state, action) => {
        console.log("GET_LITE_SERVER_LIST_SUCCESS - ", action.payload);
        const { isSuccessed } = action.payload;

        if (isSuccessed) {
            const { list_liteServer } = action.payload;

            let clist_configLiteServer = [];

            if (list_liteServer && list_liteServer.length > 0) {
                clist_configLiteServer = list_liteServer.map(row => ({
                    liteLocalSiteSeq    : row.LITE_LCL_SITE_SEQ === null ? -1 : row.LITE_LCL_SITE_SEQ,
                    liteLocalSiteName   : row.LITE_LCL_SITE_NAME === null ? "-" : row.LITE_LCL_SITE_NAME,
                    liteServerSeq       : row.LITE_LCL_SVR_SEQ,
                    liteServerName      : row.LITE_LCL_SVR_NM === null ? "-" : row.LITE_LCL_SVR_NM,
                    liteServerMemo      : row.LITE_LCL_SVR_MEMO,
                    ipAddress           : row.IP_ADDRESS === null ? "-" : row.IP_ADDRESS,
                    authCode            : row.AUTH_CD,
                    initStatus          : row.INIT_YN,
                    publicStatus        : row.PUBLIC_YN,
                    // 20260828 관리자 화면 상세정보(생성일/방송시작·접속시각) 표시용
                    createDt            : row.CREATE_DT,
                    startDateTime       : row.START_DATE_TIME
                }));
            }

            return {
                ...state,
                list_configLiteServer: clist_configLiteServer
            }
        } else {
            console.log("GET_LITE_SERVER_LIST_SUCCESS - ", action.payload);

            return {
                ...state,
                list_configLiteServer: []
            }
        }
    },

    // 260805 관리자 MEDIA 탭용 - 미디어 수프 게이트웨이 서버 전체 목록 조회 결과 처리
    [GET_MEDIA_GATEWAY_LIST_SUCCESS]: (state, action) => {
        console.log("GET_MEDIA_GATEWAY_LIST_SUCCESS - ", action.payload);
        const { isSuccessed } = action.payload;

        if (isSuccessed) {
            const { list_mediaGateWay } = action.payload;

            let clist_mediaGateWay = [];

            if (list_mediaGateWay && list_mediaGateWay.length > 0) {
                clist_mediaGateWay = list_mediaGateWay.map(row => ({
                    mediaGateWay        : row.MEDIA_GATEWAY,
                    ipAddress           : row.IP_ADDRESS === null ? "-" : row.IP_ADDRESS,
                    isActive            : row.MEDIA_GATEWAY_STAT === "Y",
                    lastLoginDt         : row.GATEWAY_LOGIN_DT === null ? "-" : row.GATEWAY_LOGIN_DT,
                    lastLogoutDt        : row.GATEWAY_LOGOUT_DT === null ? "-" : row.GATEWAY_LOGOUT_DT
                }));
            }

            return {
                ...state,
                list_mediaGateWay: clist_mediaGateWay
            }
        } else {
            console.log("GET_MEDIA_GATEWAY_LIST_SUCCESS - ", action.payload);

            return {
                ...state,
                list_mediaGateWay: []
            }
        }
    },

    [CREATE_LITE_SERVER_SUCCESS]: (state, action) => {
        const { liteServerMemo } = action.parms;
        const { isSuccessed } = action.payload;
        console.log("CREATE_LITE_SERVER_SUCCESS - ", action.payload, action.parms);

        if (isSuccessed) {
            const { isCreateSuccess } = action.payload;

            if (isCreateSuccess) {
                const { liteServerSEQ, authCode } = action.payload;

                const newServer_info = {
                    liteLocalSiteSeq    : -1,
                    liteLocalSiteName   : "-",
                    liteServerSeq       : liteServerSEQ,
                    liteServerName      : "-",
                    liteServerMemo      : liteServerMemo,
                    ipAddress           : null,
                    authCode            : authCode,
                    initStatus          : "N",
                    publicStatus        : "N"
                };

                console.log("newServer_info - ", newServer_info);

                return {
                    ...state,
                    list_configLiteServer : state.list_configLiteServer.concat(newServer_info),
                    alertKind           : ConstData.ALERT_KIND.SUCCESS,
                    alertMessage        : i18n.t("라이트_서버_등록_성공", { ns: "admin" })
                }
            } else {
                console.log("CREATE_LITE_SERVER_SUCCESS - isCreateSuccess => ", isCreateSuccess);

                return {
                    ...state,
                    alertKind           : ConstData.ALERT_KIND.DANGER,
                    alertMessage        : i18n.t("라이트_서버_등록_실패", { ns: "admin" }) + " (Code.ALL202)"
                }
            }
        } else {
            console.log("CREATE_LITE_SERVER_SUCCESS - isSuccessed is false");
            return {
                ...state,
                alertKind               : ConstData.ALERT_KIND.DANGER,
                alertMessage            : i18n.t("라이트_서버_등록_요청_실패", { ns: "admin" }) + " (Code.ALL201)"
            }
        }
    },

    [REMOVE_LITE_SERVER_SUCCESS]: (state, action) => {
        const { authCode } = action.parms;
        const { isSuccessed } = action.payload;

        if (isSuccessed) {
            const { isDeleteSuccess } = action.payload;

            if (isDeleteSuccess) {
                return {
                    ...state,
                    list_configLiteServer   : state.list_configLiteServer.filter(info => info.authCode !== authCode),
                    alertKind               : ConstData.ALERT_KIND.SUCCESS,
                    alertMessage            : i18n.t("라이트_서버_삭제_성공", { ns: "admin" })
                }
            } else {
                console.log("REMOVE_LITE_SERVER_SUCCESS - isDeleteSuccess => ", isDeleteSuccess);

                return {
                    ...state,
                    alertKind               : ConstData.ALERT_KIND.DANGER,
                    alertMessage            : i18n.t("라이트_서버_삭제_실패", { ns: "admin" }) + " (Code.AL204)"
                }
            }
        } else {
            console.log("REMOVE_LITE_SERVER_SUCCESS - ", action.payload);

            return {
                ...state,
                alertKind               : ConstData.ALERT_KIND.DANGER,
                alertMessage            : i18n.t("라이트_서버_삭제_요청_실패", { ns: "admin" }) + " (Code.AL203)"
            }
        }
    },

    [CHANGE_LITE_SERVER_INFO_SUCCESS]: (state, action) => {
        const { liteServerSeq, kind, liteServerMemo, liteServerName, initStatus } = action.parms;
        const { isSuccessed } = action.payload;
        console.log("CHANGE_LITE_SERVER_INFO_SUCCESS - ", kind, action.payload, action.parms);

        // 20260828 라이트 로컬 서버 이름 인라인 수정 결과는 로컬 서버 관리 화면의 configAlert와 동일하게
        // 해당 서버 행에서만 표시한다 (페이지 상단 알림 아님)
        if (kind === "modifyName") {
            return produce(state, draft => {
                const lite_server_info = draft.list_configLiteServer.find(info => info.liteServerSeq === liteServerSeq);
                if (!lite_server_info) return;

                const isUpdateSuccess = isSuccessed && action.payload.isUpdateSuccess;

                if (isUpdateSuccess) {
                    lite_server_info.liteServerName = liteServerName;
                    lite_server_info.nameAlertKind = ConstData.ALERT_KIND.SUCCESS;
                    lite_server_info.nameAlertMessage = i18n.t("라이트_서버_이름_수정_성공", { ns: "admin" });
                } else if (isSuccessed) {
                    console.log("CHANGE_LITE_SERVER_INFO_SUCCESS - isUpdateSuccess => ", isUpdateSuccess);
                    lite_server_info.nameAlertKind = ConstData.ALERT_KIND.DANGER;
                    lite_server_info.nameAlertMessage = i18n.t("라이트_서버_이름_수정_실패", { ns: "admin" });
                } else {
                    console.log("CHANGE_LITE_SERVER_INFO_SUCCESS - isSuccessed => ", isSuccessed);
                    lite_server_info.nameAlertKind = ConstData.ALERT_KIND.DANGER;
                    lite_server_info.nameAlertMessage = i18n.t("라이트_서버_이름_수정_요청_실패", { ns: "admin" });
                }
                lite_server_info.nameAlertEventId = (lite_server_info.nameAlertEventId || 0) + 1;
            });
        }

        if (isSuccessed) {
            const { isUpdateSuccess } = action.payload;

            if (isUpdateSuccess) {
                if (kind === "modify") {
                    return produce (state, draft => {
                        const lite_server_info = draft.list_configLiteServer.find(info => info.liteServerSeq === liteServerSeq);

                        if (lite_server_info) {
                            lite_server_info.liteServerMemo = liteServerMemo;
                        }
                    });
                } else if (kind === "init") {
                    return produce (state, draft => {
                        const lite_server_info = draft.list_configLiteServer.find(info => info.liteServerSeq === liteServerSeq);

                        if (lite_server_info) {
                            lite_server_info.initStatus = initStatus;
                        }
                    });
                } else {
                    return {
                        ...state
                    }
                }
            } else {
                console.log("CHANGE_LITE_SERVER_INFO_SUCCESS - isUpdateSuccess => ", isUpdateSuccess);

                return {
                    ...state
                }
            }
        } else {
            console.log("CHANGE_LITE_SERVER_INFO_SUCCESS - isSuccessed => ", isSuccessed);

            return {
                ...state
            }
        }
    },

    /**********************************************************/
    /////////////////////// 컨텐츠 선생님 //////////////////////
    /**********************************************************/
    // 목록 조회 성공
    [GET_ALL_CONTENT_TEACHERS_SUCCESS]: (state, action) => {
        const { isSuccessed } = action.payload;
        if (isSuccessed) {
            const { list_teacher } = action.payload;
            return {
                ...state,
                // DB 컬럼명(TEACHER_SEQ, TEACHER_NAME, USE_YN)을
                // 컴포넌트에서 쓰는 필드명으로 변환
                list_contentTeacher: list_teacher.map(t => ({
                    id          : t.TEACHER_SEQ,
                    teacherName : t.TEACHER_NAME,
                    isActive    : t.USE_YN === "Y"
                }))
            };
        }
        return state;
    },

    // 일괄 생성 성공 → 목록 재조회를 트리거하거나 낙관적 업데이트
    [CREATE_CONTENT_TEACHERS_SUCCESS]: (state, action) => {
        const { isSuccessed } = action.payload;
        // 서버가 생성된 행의 SEQ를 반환하지 않으므로,
        // 성공 시 컴포넌트에서 getAllContentTeachers를 다시 호출하도록
        // isNeedRefresh 플래그만 세웁니다.
        return {
            ...state,
            isNeedTeacherRefresh: isSuccessed === true
        };
    },

    // 사용여부 변경 성공 → 해당 항목만 토글
    [UPDATE_TEACHER_USE_YN_SUCCESS]: (state, action) => {
        const { isSuccessed, isUpdateSuccess } = action.payload;
        const { teacherSeq, useYn } = action.parms;    // createRequestThunk가 parms에 원본 인자 보존
        if (isSuccessed && isUpdateSuccess) {
            return produce(state, draft => {
                const teacher = draft.list_contentTeacher.find(t => t.id === teacherSeq);
                if (teacher) teacher.isActive = (useYn === "Y");
            });
        }
        return state;
    },

    // 이름 변경 성공 → 해당 항목 이름만 업데이트
    [UPDATE_TEACHER_NAME_SUCCESS]: (state, action) => {
        const { isSuccessed, isUpdateSuccess } = action.payload;
        const { teacherSeq, teacherName } = action.parms;
        if (isSuccessed && isUpdateSuccess) {
            return produce(state, draft => {
                const teacher = draft.list_contentTeacher.find(t => t.id === teacherSeq);
                if (teacher) teacher.teacherName = teacherName;
            });
        }
        return state;
    },

    // 정보 업데이트 성공 → 해당 항목만 수정
    [UPDATE_TEACHER_INFO_SUCCESS]: (state, action) => {
        const { isSuccessed, isUpdateSuccess } = action.payload;
        const { teacherSeq, teacherName, useYn } = action.parms;
        if (isSuccessed && isUpdateSuccess) {
            return produce(state, draft => {
                const teacher = draft.list_contentTeacher.find(t => t.id === teacherSeq);
                if (teacher) {
                    teacher.teacherName = teacherName;
                    teacher.isActive = (useYn === "Y");
                }
            });
        }
        return state;
    },

    // 삭제 성공 → 목록에서 제거
    [DELETE_CONTENT_TEACHER_SUCCESS]: (state, action) => {
        const { isSuccessed, isDeleteSuccess } = action.payload;
        const { teacherSeq } = action.parms;
        if (isSuccessed && isDeleteSuccess) {
            return {
                ...state,
                list_contentTeacher: state.list_contentTeacher.filter(t => t.id !== teacherSeq)
            };
        }
        return state;
    },

    /**********************************************************/
    //////////////////////// 클래스 관리 ///////////////////////
    /**********************************************************/
    // 라이브 목록 조회 성공
    [GET_ALL_LIVE_LIST_SUCCESS]: (state, action) => {
        const { isSuccessed } = action.payload;
        if (isSuccessed) {
            const { list_live } = action.payload;
            return {
                ...state,
                list_adminLive: list_live.map(l => ({
                    id        : l.LIVE_SEQ,
                    liveName  : l.LIVE_NAME,
                    isActive  : l.USE_YN === "Y"
                }))
            };
        }
        return state;
    },

    // 라이브 정보 업데이트 성공 → 해당 항목만 수정
    [UPDATE_LIVE_INFO_SUCCESS]: (state, action) => {
        const { isSuccessed, isUpdateSuccess } = action.payload;
        const { liveSeq, liveName, useYn } = action.parms;
        if (isSuccessed && isUpdateSuccess) {
            return produce(state, draft => {
                const cls = draft.list_adminLive.find(c => c.id === liveSeq);
                if (cls) {
                    if (liveName !== undefined) cls.liveName = liveName;
                    if (useYn !== undefined) cls.isActive = (useYn === "Y");
                }
            });
        }
        return state;
    },

    // 라이브 삭제 성공 → 목록에서 제거
    [DELETE_LIVE_SUCCESS]: (state, action) => {
        const { isSuccessed, isDeleteSuccess } = action.payload;
        const { liveSeq } = action.parms;
        if (isSuccessed && isDeleteSuccess) {
            return {
                ...state,
                list_adminLive: state.list_adminLive.filter(c => c.id !== liveSeq)
            };
        }
        return state;
    },

    [GET_ALL_CONTENT_URLS_SUCCESS]: (state, action) => {
        const { isSuccessed } = action.payload;
        console.log("GET_ALL_CONTENT_URLS - ", action.payload);

        if (isSuccessed) {
            const { list_url } = action.payload; // 실제 API 응답 키에 맞춰 조정
            return {
                ...state,
                // DB 컬럼명(URL_SEQ, SITE_NAME, SITE_ADD, FAVICON_URL, USE_YN) →
                // 컴포넌트에서 쓰는 필드명으로 변환
                list_contentUrl: list_url.map(u => ({
                    id          : u.URL_SEQ,
                    siteName    : u.SITE_NAME,
                    siteAddress : u.SITE_ADD,
                    faviconUrl  : u.FAVICON_URL,
                    isActive    : u.USE_YN === "Y"
                }))
            };
        }
        return state;
    },

    // 일괄 생성 성공 → 목록 재조회 트리거 (Teacher와 동일하게 서버가 SEQ를 안 내려준다고 가정)
    [CREATE_CONTENT_URLS_SUCCESS]: (state, action) => {
        const { isSuccessed } = action.payload;
        console.log("CREATE_CONTENT_URLS - ", action.payload);

        return {
            ...state,
            isNeedUrlRefresh: isSuccessed === true
        };
    },

    // 정보 업데이트 성공 → 해당 항목만 수정
    [UPDATE_URL_INFO_SUCCESS]: (state, action) => {
        const { isSuccessed, isUpdateSuccess } = action.payload;
        const { urlSeq, siteName, siteAddress, faviconUrl, useYn } = action.parms;
        if (isSuccessed && isUpdateSuccess) {
            return produce(state, draft => {
                const url = draft.list_contentUrl.find(u => u.id === urlSeq);
                if (url) {
                    url.siteName    = siteName;
                    url.siteAddress = siteAddress;
                    url.faviconUrl  = faviconUrl;
                    url.isActive    = (useYn === "Y");
                }
            });
        }
        return state;
    },

    // 삭제 성공 → 목록에서 제거
    [DELETE_CONTENT_URL_SUCCESS]: (state, action) => {
        const { isSuccessed, isDeleteSuccess } = action.payload;
        const { urlSeq } = action.parms;
        if (isSuccessed && isDeleteSuccess) {
            return {
                ...state,
                list_contentUrl: state.list_contentUrl.filter(u => u.id !== urlSeq)
            };
        }
        return state;
    },

    /**********************************************************/
    /////////////////////////// RBMQ ///////////////////////////
    /**********************************************************/

    [MQ_MEDIA_SERVER_INFO]: (state, action) => {
        const { roomInfo, liveInfo } = action.payload;
        console.log("MQ_MEDIA_SERVER_INFO - ", action.payload);
        /**
         * roomInfo : [{
         *      liveSeq,
         *      workerSeq,
         *      producer : {
         *          userSeq,
         *          isVideoSend, 
         *          isAudioSend, 
         *          isMicSend 
         *      },
         *      subRoomInfo : [
         *          {
         *              roomCode,
         *              isStarted, 
         *              comsumers : [
         *                  { userSeq, isVideoRcv, isAudioRcv, isMicRcv }
         *              ]
         *          }
         *      ]
         * }]
         * 
         * liveInfo : [{
         *      liveSeq,
         *      workerSeq,
         *      receiverSeq,
         *      sender : [
         *          {
         *              userSeq,
         *              producer : { isVideoSend, isAudioSend },
         *              receiver : { isVideoRcv, isAudioRcv },
         *              micReceiver : [
         *                  { userSeq, isVideoRcv, isAudioRcv }
         *              ]
         *          }
         *      ]
         * }]
         */

        let room_info = [];
        let live_info = [];

        if (roomInfo && roomInfo.length > 0) {
            room_info = roomInfo.map(room => ({
                liveSeq         : room.liveSeq,
                workerSeq       : room.workerSeq,
                producer        : room.producer === undefined || room.producer === null ?
                                    {
                                        userSeq     : -1,
                                        isVideoSend : false,
                                        isAudioSend : false,
                                        isMicSend   : false
                                    } :
                                    {
                                        userSeq     : room.producer.userSeq,
                                        isVideoSend : room.producer.isVideoSend,
                                        isAudioSend : room.producer.isAudioSend,
                                        isMicSend   : room.producer.isMicSend
                                    },
                subRoom_info    : room.subRoomInfo === undefined || room.subRoomInfo === null ? 
                                    [] :
                                    room.subRoomInfo.map(subRoom => ({
                                        roomCode    : subRoom.roomCode,
                                        isStarted   : subRoom.isStarted,
                                        consumers   : subRoom.comsumers === undefined || subRoom.comsumers === null ?
                                                        [] :
                                                        subRoom.comsumers.sort((a, b) => {
                                                            return a.userSeq - b.userSeq;
                                                        }).map(user => ({
                                                            userSeq     : user.userSeq,
                                                            isVideoRcv  : user.isVideoRcv,
                                                            isAudioRcv  : user.isAudioRcv,
                                                            isMicRcv    : user.isMicRcv
                                                        }))
                                    }))
            }));

            if (room_info && room_info.length > 0) {
                /* room_info.forEach(room => {
                    if (room.subRoom_info && room.subRoom_info.length > 0) {
                        room.subRoom_info.forEach(subRoom => {
                            if (subRoom.consumers && subRoom.consumers.length > 0) {
                                subRoom.consumers.sort((a, b) => {
                                    return a.userSeq - b.userSeq;
                                });
                            }
                        });
                    }
                }); */
            }
        }

        if (liveInfo && liveInfo.length > 0) {
            live_info = liveInfo.map(live => ({
                liveSeq         : live.liveSeq,
                workerSeq       : live.workerSeq,
                receiverSeq     : live.receiverSeq,
                sender          : live.sender === undefined || live.sender === null ?
                                    [] :
                                    live.sender.sort((a, b) => {
                                        // userSeq가 object인 경우 처리 추가 ... by hjkim 20251030
                                        const aUserSeq = typeof a.producer?.userSeq === 'object'
                                            ? a.producer.userSeq.userSeq
                                            : a.producer?.userSeq;
                                        const bUserSeq = typeof b.producer?.userSeq === 'object'
                                            ? b.producer.userSeq.userSeq
                                            : b.producer?.userSeq;
                                        return (a.producer && b.producer) ? aUserSeq - bUserSeq : 1;
                                    }).map(sender => {
                                        // sender.userSeq 추출 (number 또는 object 처리)
                                        const extractedUserSeq = typeof sender.userSeq === 'object'
                                            ? sender.userSeq.userSeq
                                            : sender.userSeq;

                                        // producer의 userSeq 추출
                                        const producerUserSeq = sender.producer
                                            ? (typeof sender.producer.userSeq === 'object'
                                                ? sender.producer.userSeq.userSeq
                                                : sender.producer.userSeq)
                                            : null;

                                        // receiver의 userSeq 추출
                                        const receiverUserSeq = sender.receiver
                                            ? (typeof sender.receiver.userSeq === 'object'
                                                ? sender.receiver.userSeq.userSeq
                                                : sender.receiver.userSeq)
                                            : live.receiverSeq;

                                        return {
                                            userSeq     : extractedUserSeq,
                                            producer    : sender.producer === undefined || sender.producer === null ? 
                                                            {
                                                                isVideoSend : false,
                                                                isAudioSend : false
                                                            } : 
                                                            {
                                                                userSeq     : producerUserSeq,
                                                                isVideoSend : sender.producer.isVideoSend,
                                                                isAudioSend : sender.producer.isAudioSend
                                                            },
                                            receiver    : [{
                                                                userSeq         : receiverUserSeq,
                                                                isVideoRcv      : sender.receiver ? sender.receiver.isVideoRcv : false,
                                                                isAudioRcv      : sender.receiver ? sender.receiver.isAudioRcv : false,
                                                                isRoomReceiver  : true,
                                                            }].concat(sender.micReceiver === undefined || sender.micReceiver === null ? 
                                                            [] : 
                                                            sender.micReceiver.sort((a, b) => {
                                                                // micReceiver의 userSeq도 object일 수 있으므로 처리
                                                                const aMicUserSeq = typeof a.userSeq === 'object' 
                                                                    ? a.userSeq.userSeq 
                                                                    : a.userSeq;
                                                                const bMicUserSeq = typeof b.userSeq === 'object' 
                                                                    ? b.userSeq.userSeq 
                                                                    : b.userSeq;
                                                                return aMicUserSeq - bMicUserSeq;
                                                            }).map(receiver => ({
                                                                userSeq         : typeof receiver.userSeq === 'object' 
                                                                                    ? receiver.userSeq.userSeq 
                                                                                    : receiver.userSeq,
                                                                isVideoRcv      : receiver.isVideoRcv,
                                                                isAudioRcv      : receiver.isAudioRcv,
                                                                isRoomReceiver  : false,
                                                            })))
                                        };
                                    })
            }));

            if (live_info && live_info.length > 0) {
                /* live_info.forEach(live => {
                    if (live.sender && live.sender.length > 0) {
                        live.sender.sort((a, b) => {
                            return a.userSeq - b.userSeq;
                        });
                    }
                }); */
            }
        }

        /* if (roomInfo !== undefined && roomInfo !== null) {
            room_info = roomInfo.map(room => ({
                liveSeq         : room.liveSeq,
                workerSeq       : room.workerSeq,
                producer        : room.producer !== undefined && room.producer !== null ? 
                                    { userSeq         : room.producer.userSeq, 
                                    isVideoSend     : room.producer.isVideoSend, 
                                    isAudioSend     : room.producer.isAudioSend } : null,
                subRoom_info    : room.subRoomInfo !== undefined && room.subRoomInfo !== null ? 
                                    room.subRoomInfo.map(subRoom => ({
                                        roomCode      : subRoom.roomCode,
                                        isStarted     : subRoom.isStarted,
                                        consumers     : subRoom.comsumers !== undefined && subRoom.comsumers !== null ? 
                                                        subRoom.comsumers.map(user => ({
                                                            userSeq       : user.userSeq,
                                                            isVideoRcv    : user.isVideoRcv,
                                                            isAudioRcv    : user.isAudioRcv,
                                                            isMicRcv      : user.isMicRcv
                                                        })) : []
                                    })) : []
            }));
        } */

        /* if (liveInfo !== undefined && liveInfo !== null) {
            live_info = liveInfo.map(live => ({
                liveSeq         : live.liveSeq,
                receiverSeq     : live.receiverSeq,
                workerSeq       : live.workerSeq,
                sender          : live.sender !== undefined && live.sender !== null ?
                                    live.sender.map(info => ({
                                        userSeq       : info.userSeq,
                                        producer      : info.producer !== undefined && info.producer !== null ? 
                                                        { isVideoSend     : info.producer.isVideoSend,
                                                        isAudioSend     : info.producer.isAudioSend } : null,
                                        receiver      : info.receiver !== undefined && info.receiver !== null ?
                                                        { isVideoRcv      : info.receiver.isVideoRcv,
                                                        isAudioRcv      : info.receiver.isAudioRcv } : null
                                    })) : [],
            }));
        } */

        return {
            ...state,
            media_info  : { room_info, live_info }
        }
    },

    [MQ_RCV_REMOTE_FORWARD_RESULT]: (state, action) => {
        const { actionKind, success, localServerSeq, localPort, message, timestamp } = action.payload;
        console.log("MQ_RCV_REMOTE_FORWARD_RESULT - payload => ", action.payload);

        return produce(state, draft => {
            let alertKind = ConstData.NONE;
            let alertMessage = null;

            if (actionKind === "startRemoteForward") {
                if (success) {
                    console.log("로컬 서버 포트 오픈 요청 성공!!!");
                    alertKind = ConstData.ALERT_KIND.SUCCESS;
                    alertMessage = `${localServerSeq}번 로컬 서버 포트 오픈 요청 성공!`;
                } else {
                    console.log("로컬 서버 포트 오픈 요청 실패!!!");
                    alertKind = ConstData.ALERT_KIND.DANGER;
                    alertMessage = `${localServerSeq}번 로컬 서버 포트 오픈 요청 실패!`;
                }
            } else if (actionKind === "endRemoteForward") {
                if (success) {
                    console.log("로컬 서버 포트 닫기 요청 성공!!!");
                    alertKind = ConstData.ALERT_KIND.SUCCESS;
                    alertMessage = `${localServerSeq}번 로컬 서버 포트 닫기 요청 성공!`;
                } else {
                    console.log("로컬 서버 포트 닫기 요청 실패!!!");
                    alertKind = ConstData.ALERT_KIND.DANGER;
                    alertMessage = `${localServerSeq}번 로컬 서버 포트 닫기 요청 실패!`;
                }
            }

            const localServer_info = draft.list_configLocalServer.find(info => info.localServerSeq === localServerSeq);
            if (localServer_info) {
                localServer_info.remoteForwardResult = {
                    success,
                    localServerSeq,
                    localPort,
                    message,
                    timestamp,
                    alertKind,
                    alertMessage
                };
            }
        });
    },
}, initialState);

export default admin;
